import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import favLogo from '../images/star-regular-brown.svg'
import favLogoSolid from '../images/star-solid-brown.svg'
import { useAuth } from '../context/AuthContextProvider';


import { ADD_APP_ACCESS_LEVELS } from 'src/constants/AppConstants'
import ApprovalsHome from '../Approvals/approvalsHome';
import { createPreference, updatePreference, deletePreference, listPreference  } from "src/utilities/AppSyncPlusAPIs";
import { v4 as uuidv4 } from 'uuid';


import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  Box,
  Cards,
  Button,
  Header,
  Table,
  Badge,
  Autosuggest,
  ExpandableSection,
  SpaceBetween,
  Multiselect,
  ColumnLayout,
  Tabs,
  Pagination,
  Spinner,
  Flashbar,
  ButtonDropdown,
  CopyToClipboard,
  ContentLayout,
  Icon,
  PieChart,
  Select,
  HelpPanel,
  Grid,
  Steps,
  Popover,
  SegmentedControl,
  TextContent,
  Toggle,
  ToggleButton,
  Modal,
  FormField,
  Input
} from "@amzn/awsui-components-react";

import "./homepage.scss";
import { getUserRatings, submitRating, deleteRating } from "src/utilities/RatingAPIs";
import { getAutomatedAppsByOwner, updateAutomatedApp, getAutomatedAppsByStatus } from "src/utilities/AutomatedAppsAPIs";
import AutomatedAppEditForm from "./AutomatedAppEditForm";
import SkeletonCard from "./SkeletonCard";
import AppOpenSearchBar from "./AppOpenSearchBar";
import useQuickSearchForAppsLibrary from "src/Ateam-BI/AutoMate/hooks/useQuickSearchForAppsLibrary";
import { APPS_LIBRARY_REPO_SEARCH_ENABLED } from "src/Ateam-BI/AutoMate/constants";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import { addFavorite, listFavorites, delFavorite, getFavorite } from '../utilities/Favorites'
import Favorite from 'src/generic-components/Favorite';
import { appCardDefinition } from 'src/generic-components/AppCard';
import { TEMPLATE_APP, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_TEAM, TEMPLATE_APP_OUTPUT, TEMPLATE_APP_ACCOUNTING, TEMPLATE_APP_USE_CASE, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_CHART_OF_ACCOUNTS, AI_APP_SPECIFIC_FIELDS } from 'src/Ateam-BI/Templates/Constants';
import { API, graphqlOperation } from "aws-amplify";
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { setCurrentAppId } from "src/store/userAuthSlice";
import { setOrganization } from "src/store/userAuthSlice";
import { getAccessLevel } from "src/checkPageAccess"
import { TEMPLATES, APP_TYPES, APP_STATUSES } from 'src/Ateam-BI/Templates/Constants';
import Featured from "src/generic-components/Featured";
import { listFeatured } from "src/utilities/Featured";

import { fetchApps } from "../Ateam-BI/Templates/Utils/AppActivityUtils"
import BuildingWithAIModal from "../Ateam-BI/Templates/BuildingWithAIModal";
import { useSuggestedLogins } from "src/hooks/useSuggestedLogins";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"

function Apps(props) {  

    const history = useHistory();
      const userId = useSelector((globalState) => globalState.auth.userId);
      const currentStage = useSelector((globalState) => globalState.auth.currentStage)
      const [qscAddAppAccessDisabled, setQscAddAppAccessDisabled] = useState(true)
      const [racAddAppAccessDisabled, setRacAddAppAccessDisabled] = useState(true)
      const [aiAddAppAccessDisabled, setAiAddAppAccessDisabled] = useState(false)
      const [isAiAdmin, setIsAiAdmin] = useState(false)
      const [accessCheckDone, setAccessCheckDone] = useState(false)
      const [showAiAppsOnly, setShowAiAppsOnly] = useState(false)
      const [abcAddAppAccessDisabled, setAbcAddAppAccessDisabled] = useState(true)
      const ln = useLocation()
    
    
      const [products, setProducts] = useState([]);
      const [filteredProducts, setFilteredProducts] = useState([]);

      // Number of semantic (quickSearch) results in the current filteredProducts.
      // Used to render a visual separator between AI-ranked and text-matched results.
      const [semanticResultCount, setSemanticResultCount] = useState(0);
      // Set of semantic app_id strings for membership-based split (robust against
      // downstream filtering like showAiAppsOnly or sort reordering).
      const [semanticIdSet, setSemanticIdSet] = useState(new Set());

      // Immutable reference to the latest successful complete fetchApps('') result.
      // This collection is never filtered or replaced by search results and serves
      // as the hydration source for repository-search IDs (task 6.2+).
      const allAppsRef = useRef([]);

      // Repository search lifecycle (vector-similarity quick search).
      const {
        query: repoSearchQuery,
        resultAppIds,
        isSearching,
        searchError,
        runSearch,
        resetSearch,
      } = useQuickSearchForAppsLibrary(userId, '/AppsLibrary');

      // Track the last searchQuery we dispatched to runSearch so we don't
      // re-trigger when the URL hasn't actually changed (e.g. filter-only updates).
      const lastDispatchedSearchQuery = useRef('');
    
      const [isProducsLoading, setIsProducsLoading] = useState(true);
      const [appsLoadError, setAppsLoadError] = useState(null);
    
      const [organizations, setOrganizations] = useState([]);
      const [useCaseTypes, setUseCaseTypes] = useState([]);
      const [statuses, setStatuses] = useState([])
      const [allAutomationTools, setAllAutomationTools] = useState([])
      const [allAccountingVps, setAllAccountingVps] = useState([]);
      const [processOutputs, setProcessOutputs] = useState([]);
      const [appTypes, setAppTypes] = useState([]);
      const [processOwners, setProcessOwners] = useState([]);
      const [financialRelevanceValues, setFinancialRelevanceValues] = useState([]);
      const [regions, setRegions] = useState([]);
      const [accountingTeams, setAccountingTeams] = useState([]);
      const [developerTeams, setDeveloperTeams] = useState([]);
      const [cadences, setCadences] = useState([]);
      const [launchDates, setLaunchDates] = useState([]);
      const [inputDataSources, setInputDataSources] = useState([]);
      const [ledgerImpacts,setLedgerImpacts] = useState([])
      const [aiUseCaseTypes, setAiUseCaseTypes] = useState([])
      const [solutionTypes, setSolutionTypes] = useState([])
      const [soxImpacts, setSoxImpacts] = useState([])
      const [aiTags, setAiTags] = useState([])
      const [ingestionMethods, setIngestionMethods] = useState([])
      const [appBuilderOptions, setAppBuilderOptions] = useState([])
      const [currentAppsLibraryPreferences, setCurrentAppsLibraryPreferences] = useState([])
      const [preferenceButtonLoading, setPreferenceButtonLoading] = useState(false)
    
      const [allSuggestions, setAllSuggestions] = useState([])
      const [searchSuggestions, setSearchSuggestions] = useState([])
      const [favoritesMap, setFavoritesMap] = useState({});
      const [featuredMap, setFeaturedMap] = useState({});
      const [favDisabled, setFavDisabled] = useState(false);
      const [ratingsMap, setRatingsMap] = useState({});
      const [activeTabId, setActiveTabId] = useState(false);
      const [appsActiveTabId, setAppsActiveTabId] = useState("apps");
      const [changeToggle, setChangeToggle] = useState(false);
      const [currentPageIndex, setCurrentPageIndex] = useState(1);
      const [pagesCount, setPagesCount] = useState()
      const [pageItems, setPageItems] = useState()
      const [fieldMetadata, setFieldMetadata] = useState({});
      const [loader, setLoader] = useState(true);
      const [view, setView] = useState('Grid')
      const [sortBy, setSortBy] = useState('default')
      // Monotonic generation counter: incremented on every page-level operation
      // (fetch, filter change, repository search completion). Before committing
      // state (products, filteredProducts, loading, error), the captured generation
      // is compared with the current ref value — stale async operations are ignored.
      const pageOpGenRef = useRef(0);
      const [isProcessing, setIsProcessing] = useState(true)
      const [pendingReviewApps, setPendingReviewApps] = useState([]);
      const [pendingReviewLoading, setPendingReviewLoading] = useState(true);
      const [pendingReviewCount, setPendingReviewCount] = useState(null);
      const [pendingReviewFetchingMore, setPendingReviewFetchingMore] = useState(false);
      const [editingApp, setEditingApp] = useState(null);
      const [archiveConfirmApp, setArchiveConfirmApp] = useState(null);
      const [discardReason, setDiscardReason] = useState("");
      const [pendingFilterDirector, setPendingFilterDirector] = useState("");
      const [pendingFilterAppBuilder, setPendingFilterAppBuilder] = useState("");
      const [pendingFilterAppName, setPendingFilterAppName] = useState("");

      const displayPendingReviewApps = useMemo(
        () => {
          let filtered = showAiAppsOnly
            ? pendingReviewApps.filter(item => item.template_id === TEMPLATES.AI)
            : pendingReviewApps;
          if (pendingFilterAppName.trim()) {
            const nameFilter = pendingFilterAppName.trim().toLowerCase();
            filtered = filtered.filter(item => item.app_name && item.app_name.toLowerCase().includes(nameFilter));
          }
          if (pendingFilterDirector.trim()) {
            const dirFilter = pendingFilterDirector.trim().toLowerCase();
            filtered = filtered.filter(item => {
              const dir = item.director;
              if (Array.isArray(dir)) return dir.some(d => d && d.toLowerCase().includes(dirFilter));
              return dir && typeof dir === 'string' && dir.toLowerCase().includes(dirFilter);
            });
          }
          if (pendingFilterAppBuilder.trim()) {
            const builderFilter = pendingFilterAppBuilder.trim().toLowerCase();
            filtered = filtered.filter(item => {
              const owner = item.app_owner;
              if (Array.isArray(owner)) return owner.some(o => o && o.toLowerCase().includes(builderFilter));
              return owner && typeof owner === 'string' && owner.toLowerCase().includes(builderFilter);
            });
          }
          return filtered;
        },
        [pendingReviewApps, showAiAppsOnly, pendingFilterDirector, pendingFilterAppBuilder, pendingFilterAppName]
      );

      const [pendingReviewPageIndex, setPendingReviewPageIndex] = useState(1);
      const PENDING_REVIEW_PAGE_SIZE = 10;

      useEffect(() => {
        setPendingReviewPageIndex(1);
      }, [showAiAppsOnly]);

      const pendingReviewPageItems = useMemo(
        () => displayPendingReviewApps.slice(
          PENDING_REVIEW_PAGE_SIZE * (pendingReviewPageIndex - 1),
          PENDING_REVIEW_PAGE_SIZE * pendingReviewPageIndex
        ),
        [displayPendingReviewApps, pendingReviewPageIndex]
      );

      const pendingReviewPagesCount = useMemo(
        () => Math.ceil(displayPendingReviewApps.length / PENDING_REVIEW_PAGE_SIZE) || 1,
        [displayPendingReviewApps]
      );
      
      const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
      const [supervisorChainCache, setSupervisorChainCache] = useState({})
    
      const { org } = useParams()
      const [ownedBy, setOwnedBy] = useState({label:`Default`, value:``})
    
      const dispatch = useDispatch();
      const search = useLocation().search
      const searchParams = new URLSearchParams(search)
      const [orgTogglechecked,setOrgToggleChecked] = useState( org ? true : false)
      const [addFiltersBools, setAddFiltersBools] = useState({
        'tools': true,
        'statuses': true,
        'orgs': true,
        'types': true,
        'vps': false,
        'outputs': false,
        'appTypes': false,
        'processOwners': false,
        'relevance': false,
        'regions': false,
        'accountingTeams': false,
        'developerTeams': false,
        'cadence': false,
        'launchDate': false,
        'inputSourceTypes': false,
        'ledgerImpacts': false,
        'aiUseCaseTypes': true,
        'solutionTypes': false,
        'soxImpacts': false,
        'aiTags': false,
        'ingestionMethod': false,
        'appBuilders': false
      })


    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.APPS_LIBRARY);
    
      useEffect(() => {
        const handleFilters = async () => {

          await queryApps()
        }
        handleFilters()
        for (const key of searchParams.keys()) {
          
          if (addFiltersBools.hasOwnProperty(key)) {
            setAddFiltersBools((prevState) => {
              return { ...prevState, [key]: true }
            })
          }
        }
    
    
      }, [searchParams.toString(), ln.pathname, ownedBy, org])
    
      useEffect(() => {
        loadProducts();
        setActiveTabId(searchParams.get("section") ? searchParams.get("section") : 'default')
        const sectionParam = searchParams.get("section");
        if (sectionParam && ['apps', 'favorites', 'featured', 'approvals', 'unpublished'].includes(sectionParam)) {
          setAppsActiveTabId(sectionParam);
        }
    
        return () => {
          // this now gets called when the component unmounts
          dispatch(setOrganization())
        };
      }, []);
    
      useEffect(() => {
        dispatch(setCurrentAppId(''));
      }, [])

      // Initialize showAiAppsOnly from query param
      useEffect(() => {
        if (searchParams.get('aiOnly') === 'true') {
          setShowAiAppsOnly(true)
        }
      }, [])

      // ========================================================================
      // Repository search: connect URL searchQuery param to useRepositorySearch.
      //
      // - When searchQuery is non-empty AND the complete collection has loaded,
      //   fire one repository search (avoids triggering before hydration data
      //   is available).
      // - When searchQuery is cleared, reset the hook and restore default cards.
      // - Browser back/forward fires this effect naturally through searchParams.
      // ========================================================================
      useEffect(() => {
        // With repository search disabled, searchQuery belongs to the legacy
        // cached-app filter and must never dispatch an agent request.
        if (!APPS_LIBRARY_REPO_SEARCH_ENABLED) return;

        const urlQuery = (searchParams.get('searchQuery') || '').trim();

        if (urlQuery) {
          // Only start a search once the complete collection is available.
          if (allAppsRef.current.length > 0 && urlQuery !== lastDispatchedSearchQuery.current) {
            lastDispatchedSearchQuery.current = urlQuery;
            runSearch(urlQuery);
          }
        } else {
          // searchQuery was removed — reset repository state.
          if (lastDispatchedSearchQuery.current) {
            lastDispatchedSearchQuery.current = '';
            resetSearch();
          }
        }
      }, [searchParams.get('searchQuery'), isProducsLoading, runSearch, resetSearch])

      // ========================================================================
      // Hybrid search hydration: semantic results (from quickSearch) on top,
      // supplemented by client-side text matches from the full collection.
      //
      // 1. Hydrate quickSearch app_ids from allAppsRef (semantic — best matches).
      // 2. Text-match the search query against app_name and app_description in
      //    allAppsRef, excluding apps already in the semantic set.
      // 3. Combine: semantic first (preserving relevance order), then text
      //    matches (sorted by view_count for a sensible secondary ordering).
      // 4. Apply existing client-side filters to the combined set.
      //
      // This gives ~10 AI-ranked results instantly from quickSearch, plus
      // potentially dozens more from the cached collection — zero extra latency.
      // ========================================================================
      useEffect(() => {
        if (!APPS_LIBRARY_REPO_SEARCH_ENABLED) return;

        // Only hydrate after the search has completed successfully.
        if (
          resultAppIds.length > 0 &&
          allAppsRef.current.length > 0 &&
          !isSearching &&
          !searchError
        ) {
          const gen = ++pageOpGenRef.current;

          // Build O(1) lookup from the complete collection.
          // Use String keys to avoid number/string mismatch between
          // quickSearch IDs (strings) and allAppsRef app_id (may be number).
          const lookup = Object.create(null);
          for (const app of allAppsRef.current) {
            if (app.app_id != null) lookup[String(app.app_id)] = app;
          }

          // 1. Semantic results: hydrate quickSearch IDs in relevance order.
          const semanticSet = new Set();
          const semanticResults = [];
          for (const id of resultAppIds) {
            const key = String(id);
            if (lookup[key]) {
              semanticResults.push(lookup[key]);
              semanticSet.add(key);
            }
          }

          // 2. Text-match results: search name/description/tags/org/etc. in the
          //    full collection, excluding apps already in the semantic set.
          const queryLower = repoSearchQuery.toLowerCase();
          const textMatches = allAppsRef.current.filter(app => {
            if (semanticSet.has(String(app.app_id))) return false;
            return matchesTextSearch(app, queryLower);
          });
          // Sort text matches by view_count (most popular first).
          textMatches.sort((a, b) => (b.view_count || 0) - (a.view_count || 0));

          // 3. Combine: semantic first, then text matches.
          const combined = [...semanticResults, ...textMatches];

          // 4. Apply client-side filters and commit.
          // Track how many semantic results survive filtering for the visual separator.
          const semanticIds = new Set(semanticResults.map(a => String(a.app_id)));
          const hydrateAndFilter = async () => {
            const filtered = await applyClientSideFilter(combined);
            if (gen !== pageOpGenRef.current) return;
            const survivingSemantic = filtered.filter(a => semanticIds.has(String(a.app_id))).length;
            setSemanticResultCount(survivingSemantic);
            setSemanticIdSet(semanticIds);
            setFilteredProducts(filtered);
            setCurrentPageIndex(1);
          };
          hydrateAndFilter();
        } else if (resultAppIds.length === 0 && repoSearchQuery && !isSearching && !searchError) {
          // quickSearch returned zero results — fall back to pure text match.
          if (allAppsRef.current.length > 0) {
            const gen = ++pageOpGenRef.current;
            const queryLower = repoSearchQuery.toLowerCase();
            const textMatches = allAppsRef.current.filter(app => {
              return matchesTextSearch(app, queryLower);
            });
            textMatches.sort((a, b) => (b.view_count || 0) - (a.view_count || 0));

            const filterAndCommit = async () => {
              const filtered = await applyClientSideFilter(textMatches);
              if (gen !== pageOpGenRef.current) return;
              setSemanticResultCount(0);
              setSemanticIdSet(new Set());
              setFilteredProducts(filtered);
              setCurrentPageIndex(1);
            };
            filterAndCommit();
          } else {
            ++pageOpGenRef.current;
            setSemanticResultCount(0);
            setSemanticIdSet(new Set());
            setFilteredProducts([]);
            setCurrentPageIndex(1);
          }
        }
        // When resultAppIds is empty AND repoSearchQuery is also empty, the
        // user cleared/reset the search — the normal queryApps filter flow
        // handles restoring the default collection.
      }, [resultAppIds, repoSearchQuery, isSearching, searchError])

      // ========================================================================
      // Sort management for repository search:
      // - Default to "relevance" when repository results become active so that
      //   citation order is preserved without user intervention.
      // - Restore the normal default sort ("most_viewed") when the search is
      //   cleared and repository results are no longer active.
      //
      // Requirements: 7.2, 7.3, 7.5
      // ========================================================================
      useEffect(() => {
        if (!APPS_LIBRARY_REPO_SEARCH_ENABLED) return;

        if (repoSearchQuery && resultAppIds.length > 0 && !isSearching && !searchError) {
          // Repository results just arrived — switch to relevance sort unless
          // the user already explicitly picked a different sort.
          if (sortBy === 'default') {
            setSortBy('relevance');
          }
        } else if (!repoSearchQuery && sortBy === 'relevance') {
          // Search was cleared — restore the normal default sort.
          setSortBy('default');
        }
      }, [repoSearchQuery, resultAppIds, isSearching, searchError])

      useEffect(() => {
        if (userId && accessCheckDone) {
          const isTabActive = appsActiveTabId === 'unpublished';
          // Only fetch if we haven't loaded yet (avoid refetch on tab switch)
          if (pendingReviewApps.length === 0 && pendingReviewCount === null) {
            if (isTabActive) setPendingReviewLoading(true);

            const onSuccess = (result) => {
              let items;
              if (isAiAdmin) {
                const rawData = result?.data?.getAutomatedAppsByStatus;
                const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
                items = parsed?.items || parsed || [];
              } else {
                const rawData = result?.data?.getAutomatedAppsByOwner;
                const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
                items = parsed?.items || parsed || [];
              }
              setPendingReviewCount(items.length);
              setPendingReviewApps(items);
              setPendingReviewLoading(false);
              setPendingReviewFetchingMore(!!result?.loading);
            };

            const onFailure = (error) => {
              console.error("Error fetching pending review apps:", error);
              setPendingReviewApps([]);
              setPendingReviewLoading(false);
              setPendingReviewFetchingMore(false);
            };

            if (isAiAdmin) {
              getAutomatedAppsByStatus("UNPUBLISHED", onSuccess, onFailure);
            } else {
              getAutomatedAppsByOwner(userId, "UNPUBLISHED", onSuccess, onFailure);
            }
          }
        }
      }, [appsActiveTabId, userId, accessCheckDone])
    
      useEffect(() => {
        checkAddAppAccesses()
      }, [userId, currentStage])
    
      useEffect(() => {
        dispatch(setOrganization(org))
        if(org) {
          setOrgToggleChecked(true)
        } else {
          setOrgToggleChecked(false)
        }
      }, [org])
    
      useEffect(()=>{
        if(typeof(orgTogglechecked) === 'boolean' && orgTogglechecked === false && org){
    
            if(searchParams.toString()) {
              history.push(`/AppsLibrary?${searchParams.toString()}`)
            } else {
              history.push(`/AppsLibrary`)
            }
        } else {
          setOwnedBy()
        }
      },[orgTogglechecked])
    
    
      // Whether repository search results are currently active (non-empty
      // query with hydrated results). Used to determine if "Relevance" sort
      // should be available and whether to preserve citation order.
      const isRepoResultsActive = Boolean(
        APPS_LIBRARY_REPO_SEARCH_ENABLED &&
        repoSearchQuery &&
        resultAppIds.length > 0
      );

      // AI search mode: with the hybrid approach (semantic + text match),
      // filters remain visible and composable with search results.
      const searchModeActive = false;

      const displayProducts = useMemo(
        () => {
          let items = showAiAppsOnly
            ? filteredProducts.filter(item => item.template_id === TEMPLATES.AI)
            : filteredProducts;
          // When "relevance" is selected (the default during repository search),
          // preserve citation order — do not re-sort the hydrated subset.
          if (sortBy === 'relevance') {
            return items;
          }
          if (sortBy === 'default') {
            // Default view: featured apps first, then most-viewed within each group.
            // Featured membership is computed from featuredMap, which is sourced from
            // DynamoDB via listFeatured (SYSTEM_USER#featuredABCApp) and keyed by app_id.
            items = [...items].sort((a, b) => {
              const aFeatured = featuredMap[a.app_id] ? 1 : 0;
              const bFeatured = featuredMap[b.app_id] ? 1 : 0;
              if (aFeatured !== bFeatured) return bFeatured - aFeatured; // featured first
              return (b.view_count || 0) - (a.view_count || 0);         // then most-viewed
            });
          } else if (sortBy === 'most_viewed') {
            items = [...items].sort((a, b) => (b.view_count || 0) - (a.view_count || 0));
          } else if (sortBy === 'highest_rated') {
            items = [...items].sort((a, b) => (b.rating_avg || 0) - (a.rating_avg || 0));
          } else if (sortBy === 'name_asc') {
            items = [...items].sort((a, b) => (a.app_name || '').toLowerCase().localeCompare((b.app_name || '').toLowerCase()));
          } else if (sortBy === 'newest') {
            items = [...items].sort((a, b) => (b.created_time_stamp || 0) - (a.created_time_stamp || 0));
          }
          return items;
        },
        [filteredProducts, showAiAppsOnly, sortBy, featuredMap]
      );

      const favoriteProducts = useMemo(
        () => filteredProducts.filter(item => favoritesMap[item.app_id]),
        [filteredProducts, favoritesMap]
      );

      const featuredProducts = useMemo(
        () => filteredProducts.filter(item => featuredMap[item.app_id]),
        [filteredProducts, featuredMap]
      );

      useEffect(() => {
        setPageItems(
          displayProducts
            .slice(21 * (currentPageIndex - 1), 21 * (currentPageIndex))
        )
        setPagesCount(Math.ceil(displayProducts.length / 21))
        if (!isProcessing) {
          setLoader(false);
        }
      }, [currentPageIndex, displayProducts, isProcessing])

      // Split the current page items into semantic and text-match portions
      // for the visual separator. Uses membership in semanticIdSet rather than
      // positional slicing — robust against downstream filtering (showAiAppsOnly,
      // sort changes) that can reorder or remove items.
      const { semanticPageItems, textMatchPageItems } = useMemo(() => {
        if (!pageItems || !repoSearchQuery || semanticIdSet.size === 0 || sortBy !== 'relevance') {
          return { semanticPageItems: null, textMatchPageItems: null };
        }
        const semantic = pageItems.filter(a => semanticIdSet.has(String(a.app_id)));
        const textMatch = pageItems.filter(a => !semanticIdSet.has(String(a.app_id)));
        return { semanticPageItems: semantic, textMatchPageItems: textMatch };
      }, [pageItems, repoSearchQuery, semanticIdSet, sortBy]);
    
    
      useEffect(() => {
        const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
        setOrganizations(orgs);
    
    
        const types = fieldMetadata[TEMPLATE_APP.USE_CASE]?.values;
        setUseCaseTypes(types);
    
        const processOutputs = fieldMetadata[TEMPLATE_APP.OUTPUT]?.values;
        setProcessOutputs(processOutputs);
    
        const allStatuses = fieldMetadata[TEMPLATE_APP.STATUS]?.values;
        setStatuses(allStatuses);
    
        const allAppAutomationTools = [
            ...(fieldMetadata[TEMPLATE_APP.AUTOMATION_TOOLS]?.values || []),
            ...(fieldMetadata[AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL]?.values || [])
        ].filter((v, i, a) => a.findIndex(t => t.value === v.value) === i);
        setAllAutomationTools(allAppAutomationTools);

        const aiUseCaseTypeValues = fieldMetadata[AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE]?.values;
        setAiUseCaseTypes(aiUseCaseTypeValues || []);

        const solutionTypeValues = fieldMetadata[AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE]?.values;
        setSolutionTypes(solutionTypeValues || []);

        const soxImpactValues = fieldMetadata[AI_APP_SPECIFIC_FIELDS.SOX_IMPACT]?.values;
        setSoxImpacts(soxImpactValues || []);

        const aiTagValues = fieldMetadata[AI_APP_SPECIFIC_FIELDS.TAGS]?.values;
        setAiTags(aiTagValues || []);

        setIngestionMethods([
            { label: "Automated", value: "Automated" },
            { label: "Manual", value: "Manual" },
            { label: "Manual Bulk Upload", value: "Manual Bulk Upload" }
        ]);
    
        const financialRelevances = fieldMetadata[TEMPLATE_APP.FINANCIAL_RELEVANCE]?.values;
        setFinancialRelevanceValues(financialRelevances)
    
        const regions = fieldMetadata[TEMPLATE_APP.REGION]?.values
        setRegions(regions)
    
        const accountingTeams = fieldMetadata[TEMPLATE_APP.ACCOUNTING_TEAM]?.values
        setAccountingTeams(accountingTeams)
    
        const developerTeams = fieldMetadata[TEMPLATE_APP.DEVELOPER_TEAM]?.values
        setDeveloperTeams(developerTeams)
    
        const cadence = fieldMetadata[TEMPLATE_APP.CADENCE]?.values
        setCadences(cadence)
        const launchDate = fieldMetadata[TEMPLATE_APP.LAUNCH_QQ_YY]?.values
        setLaunchDates(launchDate)
    
        const inputSourceType = fieldMetadata[TEMPLATE_APP.INPUT_SOURCE_TYPE]?.values
        setInputDataSources(inputSourceType)
        const ledgerImpacts = fieldMetadata[TEMPLATE_APP.LEDGER_INFO]?.values
        setLedgerImpacts(ledgerImpacts)
      }, [fieldMetadata])
    
      useEffect(() => {
    
        const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
        setOrganizations(orgs);
    
    
        const types = fieldMetadata[TEMPLATE_APP.USE_CASE]?.values;
        setUseCaseTypes(types);
    
        const processOutputs = fieldMetadata[TEMPLATE_APP.OUTPUT]?.values;
        setProcessOutputs(processOutputs);
    
        const suggestions = products.map((product) => (
          {
            value: product.app_name,
            description: product.app_description
          }
        ))
        setAllSuggestions(suggestions)
        setSearchSuggestions(suggestions)
    
        setPagesCount(Math.ceil(products.length / 21))
      }, [products]);

      useEffect(() => {

        if(props.closePortalowner) {
          listPreference(
                      props.closePortalowner.value,                        
                      'CLOSE_PORTAL',                  
                      'APPS_LIBRARY_FILTER_CONFIG',      
                      function onSuccessResponse(response) {
                          const preferences = response?.data?.listPreference?.items || [];
                          
                          const validPreferences = preferences.filter(pref => {
                              if (pref.information) {
                                  const information = typeof pref.information === 'string'
                                      ? JSON.parse(pref.information)
                                      : pref.information;
                                  return information;
                              }
                              return false;
                          });

                          setCurrentAppsLibraryPreferences(validPreferences)

                          const currentPath = ln.pathname.replace(/\/Page\/[^/?]+/, `/Page/${props.closePortalowner.value}`);

                          if(validPreferences?.length > 0) {
                            const info = JSON.parse(validPreferences[0]?.information)
                            if(info?.viewAs) {
                              setOwnedBy({label: info?.viewAs, value: info?.viewAs})
                            }
                            if(info?.path) {
                              if (!ln.pathname?.toLowerCase()?.startsWith('/closeportal/')) {
                                history.push(info?.path)
                              } else {
                                // Apply saved preferences for this team
                                const savedUrl = new URL(info.path, window.location.origin);
                                const savedSearch = savedUrl.search;
                                if (savedSearch) {
                                  history.replace(`${currentPath}${savedSearch}`);
                                }
                                // Apply aiOnly filter from saved preferences
                                const savedParams = new URLSearchParams(savedSearch);
                                if (savedParams.get('aiOnly') === 'true') {
                                  setShowAiAppsOnly(true);
                                } else {
                                  setShowAiAppsOnly(false);
                                }
                              }
                            }
                          } else {
                            // No preferences for this team — clear previous filters
                            if (ln.pathname?.toLowerCase()?.startsWith('/closeportal/')) {
                              history.replace(currentPath);
                              setShowAiAppsOnly(false);
                              setOwnedBy({label:`Default`, value:``})
                            }
                          }

          
                      },
                      function onFailureResponse(error) {
                          
                      }
                  );
        }

      },[props.closePortalowner])
    
    
      const checkAddAppAccesses = async () => {
        if (userId && currentStage) {
          let abcAccess = await getAccessLevel(userId, TEMPLATES.MAPLE, currentStage)
          let qscAccess = await getAccessLevel(userId, TEMPLATES.QSC, currentStage)
          let racAccess = await getAccessLevel(userId, TEMPLATES.RAC, currentStage)
          let aiAccess = await getAccessLevel(userId, TEMPLATES.AI, currentStage)
          // let racAccess = await getAccessLevel(userId, TEMPLATES.RAC, currentStage)
          setAbcAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(abcAccess?.appAccessLevel))
          setQscAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(qscAccess?.appAccessLevel))
          setRacAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(racAccess?.appAccessLevel))
          setAiAddAppAccessDisabled(false)
          setIsAiAdmin(ADD_APP_ACCESS_LEVELS.includes(aiAccess?.appAccessLevel))
          setAccessCheckDone(true)
          // setRacAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(racAccess?.appAccessLevel))
        }
    
      }
    
    
      const generateFilterDropdown = (allApps, dynamoDBKey) => {
        const valueSet = new Set();
        allApps
          .filter(p => p[dynamoDBKey] && p[dynamoDBKey] !== '' && p[dynamoDBKey] !== 'To be updated')
          .forEach(p => p[dynamoDBKey].forEach(val => { if (val !== 'nan') valueSet.add(val.trim()) }));
        const dropDown = [...valueSet].map(val => ({ label: val, value: val }));
        if (dynamoDBKey === TEMPLATE_APP.VP) setAllAccountingVps(dropDown);
        else if (dynamoDBKey === TEMPLATE_APP.PROCESS_OWNER) setProcessOwners(dropDown);
      }
    
      const generateAppTypesFilterDropdown = (allApps) => {
        const valueSet = new Set();
        allApps
          .filter(p => p[TEMPLATE_APP.TEMPLATE_ID] && p[TEMPLATE_APP.TEMPLATE_ID] !== '' && p[TEMPLATE_APP.TEMPLATE_ID] !== 'To be updated' && p[TEMPLATE_APP.TEMPLATE_ID] !== 'nan')
          .forEach(p => valueSet.add(p[TEMPLATE_APP.TEMPLATE_ID].trim()));
        setAppTypes([...valueSet].map(val => ({ label: APP_TYPES[val], value: val })));
      }
    
      const clearFavoriteMap = () => {
        let current_keys = Object.keys(favoritesMap)
        current_keys.forEach((key) => {
          delete favoritesMap[key]
        });
      }
    
      const makeFavoriteMap = (items) => {
        items.forEach((item, index) => {
          favoritesMap[item.preference_identifier] = true
        });
      }
    
      const getAllFavorites = async () => {
        listFavorites(userId, function onSuccess(result) {
          clearFavoriteMap()
          makeFavoriteMap(result.data.listUserPreferences.items)
          setFavoritesMap({ ...favoritesMap })
          setFavDisabled(false)
        },
          function onFailure(result) {
    
          })
      }

      const getAllFeaturedApps = async () => {
        listFeatured(function onSuccess(result) {
          const items = result.data.listUserPreferences.items || [];
          const map = {};
          items.forEach((item) => { map[item.preference_identifier] = true; });
          setFeaturedMap(map);
        },
          function onFailure(result) {}
        )
      }
    
      const isFavorite = async (appId) => {
        getFavorite(appId, userId, function onSuccess(result) {
          favoritesMap[appId] = true
        },
          function onFailure(result) {
            favoritesMap[appId] = false
          })
      }
    
      const getItemsForFilterFromDropdown = (items) => {
        let res = []
        items.forEach((item) => {
          res.push(item.value)
        })
        return res
      }

      const onSaveAppFiltersClick = async () => {
        if(props?.closePortalowner) {
          setPreferenceButtonLoading(true)
          
          const newPreferenceId = uuidv4();
          const information = { "closePortalOwner" : props?.closePortalowner?.value , "path" : `${ln.pathname}${location.search}`, "viewAs" : ownedBy?.hasOwnProperty('value') ? ownedBy?.value : null }
          const label = `Apps Library Filter Config for CP Page ${props?.closePortalowner?.label}`
          if(currentAppsLibraryPreferences?.length <= 0) {
            createPreference(
            newPreferenceId,
            'APPS_LIBRARY_FILTER_CONFIG',
            label,
            props?.closePortalowner?.value,                 
            'CLOSE_PORTAL',           
            userId,
            information,
            null,              
            (response) => {
                const newPreference = {
                    preferenceId: newPreferenceId,
                    label: label,
                    associationId: props?.closePortalowner?.value,
                    associationIdType: 'CLOSE_PORTAL',
                    preferenceType: 'APPS_LIBRARY_FILTER_CONFIG',
                    createdBy: userId,
                    lastUpdatedBy: userId,
                    lastUpdatedTimestamp: Date.now().toString(),
                    information: information
                };
                setCurrentAppsLibraryPreferences([newPreference]);
                setPreferenceButtonLoading(false)
            },
            (error) => {
                console.error('Error creating preferences:', error);
                const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
                setPreferenceButtonLoading(false)
            }
        );
          } else {
            const currentPreferenceId = currentAppsLibraryPreferences[0]?.preferenceId
            updatePreference(
              currentPreferenceId,
              label,         
              userId,
              information,
              (response) => {
                  const newPreference = {
                      preferenceId: currentPreferenceId,
                      label: label,
                      associationId: props?.closePortalowner?.value,
                      associationIdType: 'CLOSE_PORTAL',
                      preferenceType: 'APPS_LIBRARY_FILTER_CONFIG',
                      createdBy: userId,
                      lastUpdatedBy: userId,
                      lastUpdatedTimestamp: Date.now().toString(),
                      information: information
                  };
                  setCurrentAppsLibraryPreferences([newPreference]);
                  setPreferenceButtonLoading(false)
              },
              (error) => {
                  console.error('Error updating preferences:', error);
                  const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
                  setPreferenceButtonLoading(false)
              }
          )
          }
          
        }
      }

      const onResetAppFiltersClick = async () => {

        if(currentAppsLibraryPreferences?.length >= 0) {
          setPreferenceButtonLoading(true)
          const pref = currentAppsLibraryPreferences[0]
          deletePreference(pref?.preferenceId, null, () => {
            setCurrentAppsLibraryPreferences([])
            setPreferenceButtonLoading(false)
        }, (deleteError) => {
          setPreferenceButtonLoading(false)
            console.error("Error occured during deletion: ", deleteError)
        })
      }
        } 
        
    
      const getFilters = async () => {
        let qry = []
        let filtersApplied = []
        if (searchParams.get('searchQuery')) {
          qry.push(`searchString: "${searchParams.get('searchQuery')}"`)
        }
    
        if (searchParams.getAll('types')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.USE_CASE}",values:${JSON.stringify(searchParams.getAll('types'))}}`)
        }
        if (searchParams.getAll('outputs')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.OUTPUT}",values:${JSON.stringify(searchParams.getAll('outputs'))}}`)
        }
        if (searchParams.getAll('appTypes')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.TEMPLATE_ID}",values:${JSON.stringify(searchParams.getAll('appTypes').map((appType) => TEMPLATES[appType]))}}`)
        }
        if (searchParams.getAll('vps')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.VP}",values:${JSON.stringify(searchParams.getAll('vps'))}}`)
        }
        if (searchParams.getAll('tools')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.AUTOMATION_TOOLS}",values:${JSON.stringify(searchParams.getAll('tools'))}}`)
        }
    
        if (searchParams.getAll('status')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.STATUS}",values:${JSON.stringify(searchParams.getAll('status').map((status)=> APP_STATUSES[currentStage?.toUpperCase()][status]))}}`)
        }
    
        if (searchParams.getAll('processOwners')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.PROCESS_OWNER}", values:${JSON.stringify(searchParams.getAll('processOwners'))}}`)
        }
        if (searchParams.getAll('relevance')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.FINANCIAL_RELEVANCE}", values:${JSON.stringify(searchParams.getAll('relevance'))}}`)
        }
        if (searchParams.getAll('regions')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.REGION}", values:${JSON.stringify(searchParams.getAll('regions'))}}`)
        }
        if (searchParams.getAll('accountingTeams')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.ACCOUNTING_TEAM}", values:${JSON.stringify(searchParams.getAll('accountingTeams'))}}`)
        }
        if (searchParams.getAll('developerTeams')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.DEVELOPER_TEAM}", values:${JSON.stringify(searchParams.getAll('developerTeams'))}}`)
        }
        if (searchParams.getAll('cadence')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.CADENCE}", values:${JSON.stringify(searchParams.getAll('cadence'))}}`)
        }
        if (searchParams.getAll('launchDate')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.LAUNCH_QQ_YY}", values:${JSON.stringify(searchParams.getAll('launchDate'))}}`)
        }
        if (searchParams.getAll('inputSourceTypes')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.INPUT_SOURCE_TYPE}", values:${JSON.stringify(searchParams.getAll('inputSourceTypes'))}}`)
        }
        if (searchParams.getAll('ledgerImpacts')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.LEDGER_INFO}", values:${JSON.stringify(searchParams.getAll('ledgerImpacts'))}}`)
        }
        if (searchParams.getAll('aiUseCaseTypes')?.length > 0) {
          filtersApplied.push(`{type:"${AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE}", values:${JSON.stringify(searchParams.getAll('aiUseCaseTypes'))}}`)
        }
        if (searchParams.getAll('solutionTypes')?.length > 0) {
          filtersApplied.push(`{type:"${AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE}", values:${JSON.stringify(searchParams.getAll('solutionTypes'))}}`)
        }
        if (searchParams.getAll('soxImpacts')?.length > 0) {
          filtersApplied.push(`{type:"${AI_APP_SPECIFIC_FIELDS.SOX_IMPACT}", values:${JSON.stringify(searchParams.getAll('soxImpacts'))}}`)
        }
        if (searchParams.getAll('aiTags')?.length > 0) {
          filtersApplied.push(`{type:"${AI_APP_SPECIFIC_FIELDS.TAGS}", values:${JSON.stringify(searchParams.getAll('aiTags'))}}`)
        }
        if (searchParams.getAll('ingestionMethod')?.length > 0) {
          filtersApplied.push(`{type:"${AI_APP_SPECIFIC_FIELDS.INGESTION_METHOD}", values:${JSON.stringify(searchParams.getAll('ingestionMethod'))}}`)
        }
    
    
        if(ownedBy && ownedBy?.value) {
          filtersApplied.push(`{type:"owned_by", values:${JSON.stringify([ownedBy.value])}}`)
        }
    
        if (searchParams.getAll('orgs')?.length > 0 && !ln.pathname.startsWith('/AppsLibrary/Org')) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.ORGANIZATION}",values:${JSON.stringify(searchParams.getAll('orgs'))}}`)
        } else if ((ln.pathname.startsWith('/AppsLibrary/Org') || ln.pathname.startsWith('/appslibrary/org')) && org) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.ORGANIZATION}",values:${JSON.stringify([org])}}`)
        }
    
    
        if (filtersApplied?.length > 0) {
          let tempFilterQry = ''
          tempFilterQry = tempFilterQry + '['
          tempFilterQry = tempFilterQry + filtersApplied.join(',')
          tempFilterQry = tempFilterQry + ']'
          qry.push(`filters:${tempFilterQry}`)
        }
        if (qry.length > 0) {
          return `(${qry.join(",")})`
        } else {
          return ''
        }
    
      }

      const includesIgnoreCase = (str, search) =>
        str?.toLowerCase().includes(search?.toLowerCase());

      /** Check if an app matches the search query against multiple fields. */
      const matchesTextSearch = (app, queryLower) => {
        // Name and description
        if (app.app_name?.toLowerCase().includes(queryLower)) return true;
        if (app.app_description?.toLowerCase().includes(queryLower)) return true;
        // Tags
        if (app.tags?.some(t => t?.toLowerCase().includes(queryLower))) return true;
        // Organization
        if (app.organization?.some(o => o?.toLowerCase().includes(queryLower))) return true;
        // Solution Type
        if (app.solution_type?.some(s => s?.toLowerCase().includes(queryLower))) return true;
        // Use Case Type
        if (app.use_case?.some(u => u?.toLowerCase().includes(queryLower))) return true;
        // AI Use Case Type
        if (app.ai_use_case_type?.some(a => a?.toLowerCase().includes(queryLower))) return true;
        // Automation Tools
        if (app.automation_tools?.some(t => t?.toLowerCase().includes(queryLower))) return true;
        if (app.ai_automation_tool?.some(t => t?.toLowerCase().includes(queryLower))) return true;
        // SOX Impact
        if (app.sox_impact?.some(s => s?.toLowerCase().includes(queryLower))) return true;
        return false;
      };

      const hasOverlap = (itemValues, filterValues) =>
        itemValues?.some(v => filterValues.includes(v));

      const hasMatch = (itemValues, filterValues) =>
        itemValues?.some(v => filterValues.some(f => f === v));

      const applyClientSideFilter = async (allApps) => {
        let filtered_apps = [...allApps];

        // In legacy mode, search the already-fetched app collection by name
        // and description. The remaining filters below are then applied to
        // this subset, preserving the original composable search experience.
        if (!APPS_LIBRARY_REPO_SEARCH_ENABLED) {
          const searchQuery = (searchParams.get('searchQuery') || '').trim();
          if (searchQuery) {
            filtered_apps = filtered_apps.filter(app =>
              includesIgnoreCase(app?.app_name, searchQuery) ||
              includesIgnoreCase(app?.app_description, searchQuery)
            );
          }
        }

        // Client-side filtering
        const filters = {
          types: app => hasOverlap(app?.use_case, searchParams.getAll('types')),
          outputs: app => app?.output?.some(meta =>
            searchParams.getAll('outputs').some(search =>
              includesIgnoreCase(meta?.type, search)
            )
          ),
          vps: app => hasOverlap(app?.vp, searchParams.getAll('vps')),
          tools: app => hasOverlap(app?.automation_tools, searchParams.getAll('tools')) || hasOverlap(app?.ai_automation_tool, searchParams.getAll('tools')),
          status: app => searchParams.getAll('status').includes(app?.status),
          appTypes: app => (searchParams.getAll('appTypes').map((appType) => TEMPLATES[appType])).includes(app?.template_id),
          processOwners: app => hasOverlap(app?.process_owner, searchParams.getAll('processOwners')),
          relevance: app => hasOverlap(app?.financial_relevance, searchParams.getAll('relevance')),
          regions: app => hasOverlap(app?.region, searchParams.getAll('regions')),
          cadence: app => hasOverlap(app?.cadence, searchParams.getAll('cadence')),
          accountingTeams: app => app?.accounting_team?.some(team =>
            searchParams.getAll('accountingTeams').includes(team?.team)
          ),
          developerTeams: app => searchParams.getAll('developerTeams')
            .includes(app?.developer_team?.team),
          launchDate: app => searchParams.getAll('launchDate')
            .includes(app?.launch_qq_yy),
          inputSourceTypes: app => hasMatch(app?.input_source_type, searchParams.getAll('inputSourceTypes')),
          ledgerImpacts: app => hasMatch(app?.ledger_info, searchParams.getAll('ledgerImpacts')),
          aiUseCaseTypes: app => hasOverlap(app?.ai_use_case_type, searchParams.getAll('aiUseCaseTypes')),
          solutionTypes: app => hasOverlap(app?.solution_type, searchParams.getAll('solutionTypes')),
          soxImpacts: app => hasOverlap(app?.sox_impact, searchParams.getAll('soxImpacts')),
          aiTags: app => hasOverlap(app?.tags, searchParams.getAll('aiTags')),
          ingestionMethod: app => {
            const methods = app?.app_ingestion_method;
            const effectiveMethod = (methods && methods.length > 0) ? methods : ["Manual"];
            return hasOverlap(effectiveMethod, searchParams.getAll('ingestionMethod'));
          },
          appBuilders: app => {
            const owners = Array.isArray(app?.app_owner) ? app.app_owner : app?.app_owner ? [app.app_owner] : [];
            return hasOverlap(owners, searchParams.getAll('appBuilders'));
          },
          ownedBy: async app => {
            if (!ownedBy?.value) return true;
            const grcOwners = app?.grc_control_owner || [];
            if (grcOwners.some(owner => owner === ownedBy.value)) return true;
            for (const owner of grcOwners) {
              if(owner == null || owner.trim() === ''){
                continue
              }
              const supervisorChain = await getSupervisorChain(owner);
              if (supervisorChain?.toLowerCase().includes(ownedBy.value.toLowerCase())) {
                return true;
              }
            }
            return false;
          },
          orgs: app => {
            const isOrgPath = ln.pathname.toLowerCase().startsWith('/appslibrary/org');
            const filteredOrgs = isOrgPath ? [org] : searchParams.getAll('orgs');
            return app?.organization?.some(org => filteredOrgs.includes(org));
          },
        };

        for (const [key, predicate] of Object.entries(filters)) {
          const values = searchParams.getAll(key);
          if (values?.length > 0 || (key === 'orgs' && ln.pathname.toLowerCase().startsWith('/appslibrary/org') && org) || (key === 'ownedBy' && ownedBy?.value)) {
            if (key === 'ownedBy') {
              const results = await Promise.all(filtered_apps.map(predicate));
              filtered_apps = filtered_apps.filter((_, index) => results[index]);
            } else {
              filtered_apps = filtered_apps.filter(predicate);
            }
          }
        }

        return filtered_apps;
      };

      const loadProducts = async () => {
        setLoader(true)
        await getAllFavorites()
        await getAllFeaturedApps()
        await loadSearchDropDownValues();
      };



      const queryApps = async (resetCache = false) => {
        // Acquire a new generation. Any previously in-flight queryApps will
        // detect that its captured generation is stale and skip state commits.
        const gen = ++pageOpGenRef.current;
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
          setLoader(true);
          setIsProcessing(true);

          let qResultJSON;
          const maxRetries = 3;
          setAppsLoadError(null);
          for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
              qResultJSON = await fetchApps('', resetCache);
              break;
            } catch (error) {
              console.error(`GraphQL fetch error (attempt ${attempt}/${maxRetries}):`, error);
              if (attempt === maxRetries) {
                // Only commit error if this is still the latest operation.
                if (gen === pageOpGenRef.current) {
                  setAppsLoadError('Failed to load apps. Please try refreshing the page.');
                }
                return;
              }
              // Exponential backoff: 1s, 2s
              await new Promise(r => setTimeout(r, 1000 * attempt));
            }
          }

          // If a newer operation started while we were fetching, discard results.
          if (gen !== pageOpGenRef.current) return;

          // Store the complete unfiltered collection as the immutable reference.
          // This stays separate from displayed/filtered results so it can always
          // be used for hydration by repository search (task 6.2+).
          allAppsRef.current = qResultJSON;

          generateFilterDropdown(qResultJSON, TEMPLATE_APP.VP);
          generateFilterDropdown(qResultJSON, TEMPLATE_APP.PROCESS_OWNER);
          generateAppTypesFilterDropdown(qResultJSON);

          // While an AI search is active, cached/default records are hydration
          // data only — they must never be committed to the visible collection.
          // `searchQuery` remains present until Clear AI Results, so this guard
          // covers loading, empty, and error states as well as replacement
          // searches where useRepositorySearch still holds prior result IDs.
          const activeAiSearchQuery = (searchParams.get('searchQuery') || '').trim();
          const activeAiSearch = Boolean(
            APPS_LIBRARY_REPO_SEARCH_ENABLED && activeAiSearchQuery
          );
          const completedAiResultsAvailable =
            activeAiSearch &&
            repoSearchQuery === activeAiSearchQuery &&
            resultAppIds.length > 0 &&
            !isSearching &&
            !searchError;

          if (completedAiResultsAvailable) {
            // Re-hydrate semantic results + text matches from the refreshed
            // collection, maintaining citation order for semantic results.
            const lookup = Object.create(null);
            for (const app of qResultJSON) {
              if (app.app_id != null) lookup[String(app.app_id)] = app;
            }
            // Semantic results: hydrate quickSearch IDs in relevance order.
            const semanticSet = new Set();
            const hydrated = [];
            for (const id of resultAppIds) {
              const key = String(id);
              if (lookup[key]) {
                hydrated.push(lookup[key]);
                semanticSet.add(key);
              }
            }
            // Text-match results: supplement with name/description/tags/org/etc. matches.
            const queryLower = activeAiSearchQuery.toLowerCase();
            const textMatches = qResultJSON.filter(app => {
              if (semanticSet.has(String(app.app_id))) return false;
              return matchesTextSearch(app, queryLower);
            });
            textMatches.sort((a, b) => (b.view_count || 0) - (a.view_count || 0));
            const combined = [...hydrated, ...textMatches];
            const filtered = await applyClientSideFilter(combined);
            // Final staleness check after async filter.
            if (gen !== pageOpGenRef.current) return;
            const survivingSemantic = filtered.filter(a => semanticSet.has(String(a.app_id))).length;
            setSemanticResultCount(survivingSemantic);
            setSemanticIdSet(semanticSet);
            setProducts(filtered);
            setFilteredProducts(filtered);
          } else if (!activeAiSearch) {
            // Normal browsing mode: cached/default records may be displayed.
            const finalResult = await applyClientSideFilter(qResultJSON);
            // Final staleness check after async filter.
            if (gen !== pageOpGenRef.current) return;
            setProducts(finalResult);
            setAppBuilderOptions([...new Set(qResultJSON?.filter(p => p?.template_id === TEMPLATES.AI).flatMap(p => Array.isArray(p?.app_owner) ? p.app_owner : p?.app_owner ? [p.app_owner] : []).filter(Boolean))].sort().map(v => ({label: v, value: v})));
            setFilteredProducts(finalResult);
            setCurrentPageIndex(1);
          }
          // Active AI search without completed results: intentionally leave
          // filteredProducts/pageItems empty. Clear AI Results is the only path
          // that restores the cached/default collection.
        } finally {
          // Only commit terminal state if still the latest operation.
          if (gen === pageOpGenRef.current) {
            setIsProcessing(false);
            setIsProducsLoading(false);
          }
          if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.APPS_LIBRARY)
          }
        }
      };
    
      const loadSearchDropDownValues = async () => {
        let res = await getEditableFields()
        setFieldMetadata(res)
      }
      const favorite = async (appId) => {
        await isFavorite(appId)
        setFavDisabled(true)
        if (favoritesMap && favoritesMap[appId]) {
          await delFavorite(appId, userId, function onSuccess(result) {
            const updated = { ...favoritesMap };
            delete updated[appId];
            setFavoritesMap(updated);
          }, function onFailure(result) { })
        } else {
          await addFavorite(appId, userId, "default", function onSuccess(result) {
            setFavoritesMap(prev => ({ ...prev, [appId]: true }));
          }, function onFailure(result) { })
        }
        setFavDisabled(false)
      }

      const handleRatingChange = async (appId, rating) => {
        // Optimistic update
        setRatingsMap(prev => ({ ...prev, [appId]: rating }));

        if (rating === 0) {
          deleteRating(appId, "APP",
            () => {},
            (error) => {
              setRatingsMap(prev => { const copy = { ...prev }; delete copy[appId]; return copy; })
            }
          )
        } else {
          submitRating(appId, "APP", rating,
            () => {},
            (error) => {
              setRatingsMap(prev => { const copy = { ...prev }; delete copy[appId]; return copy; })
            }
          )
        }
      }

      useEffect(() => {
        if (userId) {
          getUserRatings("APP",
            (result) => {
              const ratings = result.data.getUserRatings || [];
              const map = {};
              ratings.forEach(({ entity_id, rating }) => {
                map[entity_id] = rating;
              });
              setRatingsMap(map);
            },
            (error) => {
            }
          )
        }
      }, [userId]);

      const getCommaSeperatedOutputs = (item) => {
        let types = []
        item.output.forEach((output) => {
          types.push(output.type)
        })
        return types.join(', ')
      }
    
      const getUrl = (item) => {
        if (item.url) {
          return item.url
        } else {
          return `/App/${item.app_id}`
        }
      }
    
       const getSupervisorChain = async (login) => {
         if (supervisorChainCache[login]) return supervisorChainCache[login];
         try {
           const details = await API.graphql(graphqlOperation(`
             query MyQuery {
               getEmployeeDetailsByLogin(login: "${login}")
             }
           `));
           const data = JSON.parse(details.data.getEmployeeDetailsByLogin);
           const supervisorChainLogins = data?.supervisorChain?.map((s) => s?.login) || [];
           const chain = supervisorChainLogins.join(',');
           setSupervisorChainCache(prev => ({...prev, [login]: chain}));
           return chain;
         } catch (error) {
           console.error('Error fetching supervisor chain:', error);
           return '';
         }
       };

       const cardsHeader = (
        <Header
          actions={
            (!(abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled && aiAddAppAccessDisabled) ? 
                <ButtonDropdown
                items={[
                  { text: "ATEAM App", id: "ABC_APP", "href": "/App", disabled: abcAddAppAccessDisabled },
                  { text: "QSC App", id: "QSC_APP", "href": "/QSCApp", disabled: qscAddAppAccessDisabled },
                  { text: "RAC App", id: "RAC_APP", "href": "/RACApp", disabled: racAddAppAccessDisabled },
                  { text: "AI App", id: "AI_APP", "href": "/AIApp", disabled: aiAddAppAccessDisabled },
                ]}
                variant="primary"
                expandToViewport
              disabled={abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled && aiAddAppAccessDisabled}
              >
                Add to Repository
              </ButtonDropdown> : <></>
              )
          }
        >
          {/* <SpaceBetween direction="horizontal" alignItems="center"> <span style={{color: "#656871"}}>Add an app to your favorites by clicking</span><img className="favorite_star" src={favLogo}></img></SpaceBetween> */}
        </Header>
       )

       const onFavoriteChange = () => {
        //loadProducts()
        getAllFavorites()
      }

    
      const topView = (
        
          // <div className="space-between-horizontal-flex">
          <Grid
            gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          >
                  <Box>
                    {!orgTogglechecked && (
                      <>
                      View as:
    
                      <Select
                            selectedOption={ownedBy? {label:`${ownedBy.label}`, value:`${ownedBy.value}`} : {label:`Default`, value:``}}
                            onChange={({ detail }) =>
                            setOwnedBy(detail.selectedOption)
                            }
                            placeholder="Select Alias"
                            options={suggestedLogins}
                            statusType={aliasesLoading ? "loading" : "finished"}
                            filteringType="manual"
                            loadingText="Loading aliases"
                            empty="No valid alias to recommend for entered text"
                            onLoadItems ={({detail})=>{
                              getSuggestedLoginsCaller(detail?.filteringText,10,true)
                            }}
                        />
                      <small>
                        <span style={{color: "#656871"}}>{`Apps owned by ${ownedBy?.value || 'the selected user'} or by people who report directly or indirectly to ${ownedBy?.value || 'them'}`}</span>
                      </small>
                    </>
                    )}
                 
    
                  </Box>
                  <Box float="right">
                  <ButtonDropdown
                items={[
                      {
                        text: "Organizations",
                        id: "orgs",
                        itemType: "checkbox",
                        checked: addFiltersBools.orgs,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
            
                      },
                      {
                        text: "Use Case Types",
                        id: "types",
                        itemType: "checkbox",
                        checked: addFiltersBools.types,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "App status",
                        id: "statuses",
                        itemType: "checkbox",
                        checked: addFiltersBools.statuses,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "Automation tools",
                        id: "tools",
                        itemType: "checkbox",
                        checked: addFiltersBools.tools,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "Accounting VPs",
                        id: "vps",
                        itemType: "checkbox",
                        checked: addFiltersBools.vps,
                        disabled: false
                      },
                      {
                        text: "Process Owners",
                        id: "processOwners",
                        itemType: "checkbox",
                        checked: addFiltersBools.processOwners,
                        disabled: false
                      },
                      {
                        text: "App Type",
                        id: "appTypes",
                        itemType: "checkbox",
                        checked: addFiltersBools.appTypes,
                        disabled: false
                      },
                      {
                        text: "Financial relevance",
                        id: "relevance",
                        itemType: "checkbox",
                        checked: addFiltersBools.relevance,
                        disabled: false
                      },
    
                      {
                        text: "Region",
                        id: "regions",
                        itemType: "checkbox",
                        checked: addFiltersBools.regions,
                        disabled: false
                      },
    
                      {
                        text: "Accounting team",
                        id: "accountingTeams",
                        itemType: "checkbox",
                        checked: addFiltersBools.accountingTeams,
                        disabled: false
                      },
                      {
                        text: "Developer team",
                        id: "developerTeams",
                        itemType: "checkbox",
                        checked: addFiltersBools.developerTeams,
                        disabled: false
                      },
                      {
                        text: "Run Frequency",
                        id: "cadence",
                        itemType: "checkbox",
                        checked: addFiltersBools.cadence,
                        disabled: false
                      },
                      {
                        text: "Launch date",
                        id: "launchDate",
                        itemType: "checkbox",
                        checked: addFiltersBools.launchDate,
                        disabled: false
                      },
                      {
                        text: "Input source type",
                        id: "inputSourceTypes",
                        itemType: "checkbox",
                        checked: addFiltersBools.inputSourceTypes,
                        disabled: false
                      },
                      {
                        text: "Process outputs",
                        id: "outputs",
                        itemType: "checkbox",
                        checked: addFiltersBools.outputs,
                        disabled: false
                      },
                      {
                        text: "Ledger impact",
                        id: "ledgerImpacts",
                        itemType: "checkbox",
                        checked: addFiltersBools.ledgerImpacts,
                        disabled: false
                      },
                      {
                        text: "AI Use Case Type",
                        id: "aiUseCaseTypes",
                        itemType: "checkbox",
                        checked: addFiltersBools.aiUseCaseTypes,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "Solution Type",
                        id: "solutionTypes",
                        itemType: "checkbox",
                        checked: addFiltersBools.solutionTypes,
                        disabled: false
                      },
                      {
                        text: "SOX Impact",
                        id: "soxImpacts",
                        itemType: "checkbox",
                        checked: addFiltersBools.soxImpacts,
                        disabled: false
                      },
                      {
                        text: "Tags",
                        id: "aiTags",
                        itemType: "checkbox",
                        checked: addFiltersBools.aiTags,
                        disabled: false
                      },
                      {
                        text: "App Ingestion Method",
                        id: "ingestionMethod",
                        itemType: "checkbox",
                        checked: addFiltersBools.ingestionMethod,
                        disabled: false
                      },
                      {
                        text: "AI App Builder",
                        id: "appBuilders",
                        itemType: "checkbox",
                        checked: addFiltersBools.appBuilders,
                        disabled: false
                      },
    
                      
                ]}
    
                onItemClick={(event) => {
                  
                  setAddFiltersBools({ ...addFiltersBools, [event.detail.id]: !addFiltersBools[event.detail.id] })
                  if(!addFiltersBools[event.detail.id] === false) {
                    searchParams.delete(`${event.detail.id}`)
                    history.replace({
                      ...history.location.search,
                      search: `${searchParams.toString()}`,
                    })
                  }
                }}
              >
                Add / Remove Filters
              </ButtonDropdown>
              </Box>
              </Grid>
        //     {/* <Box>
        //     <SpaceBetween direction="horizontal" size="l">
        //       <Box>
                
        //       </Box>
        //       <Box>
        //         <Toggle
        //   onChange={({ detail }) =>
        //     setOrgToggleChecked(detail.checked)
        //   }
        //   checked={orgTogglechecked}
        // >
          
        //   <Box>
        //   <small>View by organization</small>
        //   </Box>
        //   </Toggle>
        //   <Select
        //   selectedOption={org? {label:`${org}`, value:`${org}`} : {label:`All`, value:``} }
        //   onChange={({ detail }) =>
        //     history.push(`/AppsLibrary/Org/${detail.selectedOption.value}`)
        //   }
        //   options={organizations}
        //   disabled={!orgTogglechecked}
        // />
    
        //   </Box>
        //   </SpaceBetween>
        //   </Box> */}
        //   </div>
        
      )

      /**
       * Handle a repository-search submission (Enter, the Search button, or
       * picking an autocomplete suggestion — AppOpenSearchBar funnels all
       * three into this one `onSubmit` callback).
       *
       * Clears the currently-displayed application cards and hides the
       * "Filter by" panel IMMEDIATELY on submit, without waiting for the
       * `searchRepository` request to resolve — `searchModeActive` (derived
       * from the `searchQuery` URL param set here) hides the filter panel on
       * the very next render, and clearing `filteredProducts` here removes
       * the previously-displayed cards a beat before the hydration effect
       * would otherwise replace them once results arrive. The underlying
       * repository-search call itself (debounce, agent invocation,
       * hydration once results land) is unchanged.
       */
      const handleSearchSubmit = (value) => {
        // Reset pagination immediately on submit (Requirement 6.6).
        setCurrentPageIndex(1);
        if (value) {
          // Invalidate every cached/default collection operation that began
          // before this submit. Without this, a pending queryApps() response
          // can repaint cached cards after the AI-search UI has cleared them.
          ++pageOpGenRef.current;

          // Clear both the source collection and its already-paginated render
          // state synchronously. All submit paths (Enter, Search button, and
          // autocomplete selection) converge here, so cached cards disappear
          // immediately and stay hidden until AI results complete or the user
          // explicitly clicks Clear AI Results.
          setFilteredProducts([]);
          setPageItems([]);
        }
        // Empty submission is a clear/reset, not a search — filteredProducts
        // is left alone here. Removing searchQuery from the URL flips
        // searchModeActive back to false (restoring the "Filter by" panel),
        // and the existing searchQuery-watching effect calls resetSearch()
        // once it observes the param disappear — that path (unchanged)
        // restores the default collection.
        searchParams.delete(`searchQuery`)
        if (value) {
          searchParams.append(`searchQuery`, value)
        }
        history.replace({
          ...history.location.search,
          search: `${searchParams.toString()}`,
        })
      };

      /**
       * Handle the "Clear AI Results" button. Restores the pre-search page
       * state: removes `searchQuery` from the URL (which also flips
       * `searchModeActive` back to false and reveals the "Filter by" panel),
       * resets the repository-search hook, and restores the default
       * (unfiltered-by-search) application collection from the immutable
       * `allAppsRef` reference — re-running only the existing client-side
       * filters (org/team/status/etc. still in the URL), not another agent
       * call.
       */
      const handleClearResults = () => {
        setCurrentPageIndex(1);
        setSemanticResultCount(0);
        setSemanticIdSet(new Set());
        searchParams.delete('searchQuery');
        history.replace({
          ...history.location.search,
          search: `${searchParams.toString()}`,
        });
        resetSearch();
        const restoreDefaultCollection = async () => {
          const gen = ++pageOpGenRef.current;
          const filtered = await applyClientSideFilter(allAppsRef.current);
          if (gen !== pageOpGenRef.current) return;
          setFilteredProducts(filtered);
        };
        restoreDefaultCollection();
      };

    const Apps = (
        <>
        {
            (appsActiveTabId !== 'insights' && appsActiveTabId !== 'approvals') && (
              <Box>
                <div class='views'>
                  <SpaceBetween size="m" direction="horizontal">
                    {/* <img className={view == 'Grid' ? 'button_selected' : 'button_unselected'} src={grid} onClick={() => setView('Grid')}></img>
                  <img className={view == 'List' ? 'button_selected' : 'button_unselected'} src={list} onClick={() => setView('List')}></img> */}


                    {/* <SegmentedControl
                      selectedId={view}
                      onChange={({ detail }) =>
                        setView(detail.selectedId)
                      }
                      label="View segmented control"
                      options={[
                        { text: "Card view", id: "Grid" },
                        { text: "List view", id: "List" },
                      ]}
                    /> */}
                  </SpaceBetween>
                </div>
              </Box>
            )
          }
        <Tabs
                tabs={[
                  {
                    label: org ? `${org} Applications` : `All Applications`,
                    id: "apps",
                    content: (
                      <>
              {APPS_LIBRARY_REPO_SEARCH_ENABLED ? (
                <AppOpenSearchBar
                  initialValue={searchParams.get('searchQuery') || ''}
                  placeholder="Search via keyword(s) or filter by field(s) below"
                  isSearching={isSearching}
                  onSubmit={handleSearchSubmit}
                  onClear={handleClearResults}
                />
              ) : (
                // Legacy cached-app search: update searchQuery directly as the
                // user types or selects a cached suggestion. queryApps applies
                // name/description matching together with the normal filters.
                <Autosuggest
                  onChange={({ detail }) => {
                    searchParams.delete(`searchQuery`)
                    if (detail.value) {
                      searchParams.append(`searchQuery`, detail.value)
                    }
                    history.replace({
                      ...history.location,
                      search: searchParams.toString(),
                    })
                  }}
                  value={searchParams.get('searchQuery') ? searchParams.get('searchQuery') : ''}
                  placeholder={`Search ${org ? org : `all`} applications`}
                  enteredTextLabel={(value) => `Searching: ${value}`}
                  options={searchSuggestions}
                  virtualScroll
                />
              )}
              <br />
              <div style={{ position: "relative", marginBottom: "1rem" }}>
                <Box float="right" padding={{ top: "xxs" }}>
                  <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                    <Box variant="span" fontWeight="bold">Sort by:</Box>
                    <Select
                      selectedOption={sortBy ? { label: sortBy === 'relevance' ? 'Relevance' : sortBy === 'default' ? 'Default' : sortBy === 'most_viewed' ? 'Most Viewed' : sortBy === 'highest_rated' ? 'Highest Rated' : sortBy === 'name_asc' ? 'Name (A-Z)' : 'Newest', value: sortBy } : null}
                      onChange={({ detail }) => setSortBy(detail.selectedOption.value)}
                      placeholder="Sort by"
                      options={[
                        ...(isRepoResultsActive ? [{ label: "Relevance", value: "relevance" }] : []),
                        { label: "Default", value: "default" },
                        { label: "Most Viewed", value: "most_viewed" },
                        { label: "Newest", value: "newest" },
                        { label: "Highest Rated", value: "highest_rated" },
                        { label: "Name (A-Z)", value: "name_asc" },
                      ]}
                    />
                  </SpaceBetween>
                </Box>
              </div>
              <Box padding={{ bottom: "xs" }}><BuildingWithAIModal /></Box>
              {/* "Filter by" is hidden for the duration of a repository
                  search (from submit through to results/failure) and
                  restored only by "Clear AI Results" (or an equivalent empty
                  submission), which clears the searchQuery URL param. */}
              {!searchModeActive && (
              <Box>
                <ExpandableSection
                  variant="default"
                  headerText="Filter by"
                >
                  
                <Container>
                  
                
                  {topView}
                  <Box>
                  <ColumnLayout columns={4}>
                    {ln.pathname?.startsWith('/AppsLibrary/Org') && org ? (
                      <></>
                    ) : (
                      <Box>
                        <Box variant="awsui-key-label">Organizations</Box>
                        <Multiselect filteringType="auto"
                          selectedOptions={searchParams.getAll('orgs').map((org) => (
                            {
                              label: org,
                              value: org
                            }
                          ))}
                          onChange={({ detail }) => {
                            // console.log(history.location.search)
                            searchParams.delete(`orgs`)
                            detail.selectedOptions?.forEach((org) => searchParams.append(`orgs`, org.value))
    
                            history.replace({
                              ...history.location.search,
                              search: `${searchParams.toString()}`,
                            })
    
                          }
                          }
                          options={organizations}
                          placeholder="Filter on Organizations"
                        />
                      </Box>)}
    
                    <Box>
                      <Box variant="awsui-key-label">Use Case Types</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('types').map((type) => (
                          {
                            label: type,
                            value: type
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`types`)
                          detail.selectedOptions?.forEach((type) => searchParams.append(`types`, type.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={useCaseTypes}
                        placeholder="Filter on Use Case Types"
                      />
                    </Box>
    
                    <Box>
                      <Box variant="awsui-key-label">App status</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('status').map((status) => (
                          {
                            label: status,
                            value: status
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`status`)
                          detail.selectedOptions?.forEach((status) => searchParams.append(`status`, status.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={statuses}
                        placeholder="Filter on app status"
                      />
                    </Box>
    
                    <Box>
                      <Box variant="awsui-key-label">Automation tools</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('tools').map((tool) => (
                          {
                            label: tool,
                            value: tool
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`tools`)
                          detail.selectedOptions?.forEach((tool) => searchParams.append(`tools`, tool.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={allAutomationTools}
                        placeholder="Filter on automation tools"
                      />
                    </Box>

                    {addFiltersBools.vps && (
                      <Box>
                      <Box variant="awsui-key-label">Accounting VPs</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('vps').map((vp) => (
                          {
                            label: vp,
                            value: vp
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`vps`)
                          detail.selectedOptions?.forEach((vp) => searchParams.append(`vps`, vp.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={allAccountingVps}
                        placeholder="Filter on Accounting VPs"
                      />
                    </Box>
                    )}
                    
                    {addFiltersBools.processOwners && (
                    <Box>
                      <Box variant="awsui-key-label">Process owners</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('processOwners').map((processOwner) => (
                          {
                            label: processOwner,
                            value: processOwner
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`processOwners`)
                          detail.selectedOptions?.forEach((processOwner) => searchParams.append(`processOwners`, processOwner.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={processOwners}
                        placeholder="Filter on process owners"
                      />
                    </Box>
                    )}
                    
    
                  {addFiltersBools.appTypes && (
                    <Box>
                      <Box variant="awsui-key-label">App Type</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('appTypes').map((appType) => (
                          {
                            label: `${appType}`,
                            value: TEMPLATES[appType]
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`appTypes`)
                          detail.selectedOptions?.forEach((appType) => searchParams.append(`appTypes`, appType.label))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={appTypes}
                        placeholder="Filter on App type"
                      />
                    </Box>)
                    }
    
                    {addFiltersBools.relevance &&(
                      <Box>
                      <Box variant="awsui-key-label">Financial relevance</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('relevance').map((relevance) => (
                          {
                            label: relevance,
                            value: relevance
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`relevance`)
                          detail.selectedOptions?.forEach((relevance) => searchParams.append(`relevance`, relevance.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={financialRelevanceValues}
                        placeholder="Filter on financial relevance"
                      />
                    </Box>
                    )}
    
                    {addFiltersBools.regions && (
                      <Box>
                      <Box variant="awsui-key-label">Regions</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('regions').map((region) => (
                          {
                            label: region,
                            value: region
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`regions`)
                          detail.selectedOptions?.forEach((region) => searchParams.append(`regions`, region.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={regions}
                        placeholder="Filter on regions"
                      />
                    </Box>
                    )}
    
                    {addFiltersBools.accountingTeams && (
                    <Box>
                      <Box variant="awsui-key-label">Accounting teams</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('accountingTeams').map((accountingTeam) => (
                          {
                            label: accountingTeam,
                            value: accountingTeam
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`accountingTeams`)
                          detail.selectedOptions?.forEach((accountingTeam) => searchParams.append(`accountingTeams`, accountingTeam.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={accountingTeams}
                        placeholder="Filter on accounting teams"
                      />
                    </Box>
                    )}
                    {addFiltersBools.developerTeams && (
                      <Box>
                      <Box variant="awsui-key-label">Developer teams</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('developerTeams').map((developerTeam) => (
                          {
                            label: developerTeam,
                            value: developerTeam
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`developerTeams`)
                          detail.selectedOptions?.forEach((developerTeam) => searchParams.append(`developerTeams`, developerTeam.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={developerTeams}
                        placeholder="Filter on developer teams"
                      />
                    </Box>
                    )}
                    {addFiltersBools.cadence && (
                      <Box>
                      <Box variant="awsui-key-label">Run frequency</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('cadence').map((cadence) => (
                          {
                            label: cadence,
                            value: cadence
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`cadence`)
                          detail.selectedOptions?.forEach((cadence) => searchParams.append(`cadence`, cadence.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={cadences}
                        placeholder="Filter on run frequency"
                      />
                    </Box>
                    )}
                    {addFiltersBools.launchDate && (
                      <Box>
                      <Box variant="awsui-key-label">Launch date</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('launchDate').map((launchDate) => (
                          {
                            label: launchDate,
                            value: launchDate
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`launchDate`)
                          detail.selectedOptions?.forEach((launchDate) => searchParams.append(`launchDate`, launchDate.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={launchDates}
                        placeholder="Filter on launch date"
                      />
                    </Box>
                    )}
                    {addFiltersBools.inputSourceTypes && (
                      <Box>
                      <Box variant="awsui-key-label">Input source types</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('inputSourceTypes').map((inputSourceType) => (
                          {
                            label: inputSourceType,
                            value: inputSourceType
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`inputSourceTypes`)
                          detail.selectedOptions?.forEach((inputSourceType) => searchParams.append(`inputSourceTypes`, inputSourceType.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={inputDataSources}
                        placeholder="Filter on input source types"
                      />
                    </Box>
                    )}
                    {addFiltersBools.outputs && (
                    <Box>
                      <Box variant="awsui-key-label">Process output</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('outputs').map((output) => (
                          {
                            label: output,
                            value: output
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`outputs`)
                          detail.selectedOptions?.forEach((output) => searchParams.append(`outputs`, output.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={processOutputs}
                        placeholder="Filter on process outputs"
                      />
                    </Box>)
                    }
                    {addFiltersBools.ledgerImpacts && (
                      <Box>
                      <Box variant="awsui-key-label">Ledger impact</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('ledgerImpacts').map((ledgerImpact) => (
                          {
                            label: ledgerImpact,
                            value: ledgerImpact
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`ledgerImpacts`)
                          detail.selectedOptions?.forEach((ledgerImpact) => searchParams.append(`ledgerImpacts`, ledgerImpact.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={ledgerImpacts}
                        placeholder="Filter on ledger impacts"
                      />
                    </Box>
                    )}
                    {addFiltersBools.aiUseCaseTypes && (
                      <Box>
                      <Box variant="awsui-key-label">AI Use Case Type</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('aiUseCaseTypes').map((val) => ({label: val, value: val}))}
                        onChange={({ detail }) => {
                          searchParams.delete(`aiUseCaseTypes`)
                          detail.selectedOptions?.forEach((opt) => searchParams.append(`aiUseCaseTypes`, opt.value))
                          history.replace({...history.location.search, search: `${searchParams.toString()}`})
                        }}
                        options={aiUseCaseTypes}
                        placeholder="Filter on AI use case types"
                      />
                    </Box>
                    )}
                    {addFiltersBools.solutionTypes && (
                      <Box>
                      <Box variant="awsui-key-label">Solution Type</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('solutionTypes').map((val) => ({label: val, value: val}))}
                        onChange={({ detail }) => {
                          searchParams.delete(`solutionTypes`)
                          detail.selectedOptions?.forEach((opt) => searchParams.append(`solutionTypes`, opt.value))
                          history.replace({...history.location.search, search: `${searchParams.toString()}`})
                        }}
                        options={solutionTypes}
                        placeholder="Filter on solution types"
                      />
                    </Box>
                    )}
                    {addFiltersBools.soxImpacts && (
                      <Box>
                      <Box variant="awsui-key-label">SOX Impact</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('soxImpacts').map((val) => ({label: val, value: val}))}
                        onChange={({ detail }) => {
                          searchParams.delete(`soxImpacts`)
                          detail.selectedOptions?.forEach((opt) => searchParams.append(`soxImpacts`, opt.value))
                          history.replace({...history.location.search, search: `${searchParams.toString()}`})
                        }}
                        options={soxImpacts}
                        placeholder="Filter on SOX impact"
                      />
                    </Box>
                    )}
                    {addFiltersBools.aiTags && (
                      <Box>
                      <Box variant="awsui-key-label">Tags</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('aiTags').map((val) => ({label: val, value: val}))}
                        onChange={({ detail }) => {
                          searchParams.delete(`aiTags`)
                          detail.selectedOptions?.forEach((opt) => searchParams.append(`aiTags`, opt.value))
                          history.replace({...history.location.search, search: `${searchParams.toString()}`})
                        }}
                        options={aiTags}
                        placeholder="Filter on tags"
                      />
                    </Box>
                    )}
                    {addFiltersBools.ingestionMethod && (
                      <Box>
                      <Box variant="awsui-key-label">App Ingestion Method</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('ingestionMethod').map((val) => ({label: val, value: val}))}
                        onChange={({ detail }) => {
                          searchParams.delete(`ingestionMethod`)
                          detail.selectedOptions?.forEach((opt) => searchParams.append(`ingestionMethod`, opt.value))
                          history.replace({...history.location.search, search: `${searchParams.toString()}`})
                        }}
                        options={ingestionMethods}
                        placeholder="Filter on source"
                      />
                    </Box>
                    )}
                    {addFiltersBools.appBuilders && (
                      <Box>
                      <Box variant="awsui-key-label">AI App Builder</Box>
                      <Multiselect filteringType="auto"
                        selectedOptions={searchParams.getAll('appBuilders').map((val) => ({label: val, value: val}))}
                        onChange={({ detail }) => {
                          searchParams.delete(`appBuilders`)
                          detail.selectedOptions?.forEach((opt) => searchParams.append(`appBuilders`, opt.value))
                          history.replace({...history.location.search, search: `${searchParams.toString()}`})
                        }}
                        options={appBuilderOptions}
                        placeholder="Filter by app builder"
                        hideSelectedOptions={false}
                      />
                    </Box>
                    )}
                  </ColumnLayout>
                  <br></br>
                  </Box>
          <Grid
            gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          >
            {props?.addOrEditAccess && (
              <>
            {(ln.pathname?.startsWith('/ClosePortal/AppsLibrary/Page/') || (ln.pathname?.startsWith('/ClosePortal/Teams/') && new URLSearchParams(ln.search).get('tab') === 'AppsLibrary')) && (
            <Box>
              <small>
                <span style={{color: "#656871"}}>{`Save current filters as team preferences or reset to default view`}</span>
              </small>
            </Box>
            )}

              {(ln.pathname?.startsWith('/ClosePortal/AppsLibrary/Page/') || (ln.pathname?.startsWith('/ClosePortal/Teams/') && new URLSearchParams(ln.search).get('tab') === 'AppsLibrary')) && (
                <Box float="right">
                  <ButtonDropdown
                    loading={preferenceButtonLoading}
                      items={[
                          {
                              text: "Save View For Team",
                              id: "save",
                              iconName: "folder",
                          },
                          {
                              text: "Reset View",
                              id: "reset",
                              iconName: "refresh",
                              disabled: currentAppsLibraryPreferences?.length <= 0,
                              disabledReason: "No preferences sets"
                          }
                      ]}
                      onItemClick={(event) => {
                          if (event.detail.id == 'save') {
                              onSaveAppFiltersClick()
                          } else if (event.detail.id == 'reset') {
                              onResetAppFiltersClick()
                          }
                          
                      }}
                  >
                      Library Preferences
                  </ButtonDropdown>                    
                  <br></br>
                  <br></br>
                </Box>
              )}

              </>
              ) } 
            </Grid>
              </Container>
            </ExpandableSection>
              </Box>
              )}
              <br></br>
              {loader ? (<Box padding={{ top: "l" }}>
          <SkeletonCard count={9} columns={3} />
        </Box>) : (
          <>
          {appsLoadError && (
            <Flashbar items={[{
              type: 'error',
              content: appsLoadError,
              action: <Button onClick={() => queryApps(true)}>Retry</Button>,
              dismissible: true,
              onDismiss: () => setAppsLoadError(null),
              id: 'apps-load-error'
            }]} />
          )}
          {/* Repository search error — non-destructive; cards remain visible */}
          {searchError && (
            <Flashbar items={[{
              type: 'error',
              content: searchError,
              dismissible: false,
              id: 'repo-search-error'
            }]} />
          )}
          {/* Repository search loading indicator — cards stay visible beneath */}
          {isSearching && (
            <Box textAlign="center" padding={{ top: "s", bottom: "s" }}>
              <Spinner size="normal" /> Searching applications...
            </Box>
          )}
          {/* Explicit no-applications state after a clean completion with zero hydratable IDs */}
          {!isSearching && repoSearchQuery && resultAppIds.length === 0 && !searchError && filteredProducts.length === 0 ? (
            <Box textAlign="center" color="inherit" padding={{ top: "xl", bottom: "xl" }}>
              <Box variant="h3" color="inherit">No applications found</Box>
              <Box variant="p" color="inherit" padding={{ top: "s" }}>
                No applications matched your search for "{repoSearchQuery}".
              </Box>
            </Box>
          ) : (view == 'Grid' ? (
            semanticPageItems && (semanticPageItems.length > 0 || textMatchPageItems.length > 0) ? (
              <>
                <Cards
                  className="apps-cards-container"
                  cardDefinition={appCardDefinition({ favoritesMap, favDisabled, favorite, ratingsMap, handleRatingChange, getUrl, history, featuredMap })}
                  stickyHeader
                  cardsPerRow={[{ minWidth: 900, cards: 3 }]}
                  items={[]}
                  loadingText="Loading resources"
                  empty={<></>}
                  preferences = {
                    <>
                    {(!(abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled && aiAddAppAccessDisabled) ? 
                  <ButtonDropdown
                  items={[
                    { text: "ATEAM App", id: "ABC_APP", "href": "/App", disabled: abcAddAppAccessDisabled },
                    { text: "QSC App", id: "QSC_APP", "href": "/QSCApp", disabled: qscAddAppAccessDisabled },
                    { text: "RAC App", id: "RAC_APP", "href": "/RACApp", disabled: racAddAppAccessDisabled },
                    { text: "AI App", id: "AI_APP", "href": "/AIApp", disabled: aiAddAppAccessDisabled },
                  ]}
                  variant="primary"
                  expandToViewport
                disabled={abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled && aiAddAppAccessDisabled}
                >
                  Add to Repository
                </ButtonDropdown> : <></>
                )}
                    </>
                  }
                  pagination={
                    <Pagination currentPageIndex={currentPageIndex}
                      key={`main-pagination-${showAiAppsOnly}`}
                      onChange={({ detail }) =>
                        setCurrentPageIndex(detail.currentPageIndex)
                      }
                      pagesCount={Math.ceil(displayProducts.length / 21) || 1}
                      openEnd={false} />        
                  }
                  filter = {
                    <SpaceBetween direction="horizontal" size="m" alignItems="center">
                      <TextContent><h4><span style={{color: "#656871"}}>{displayProducts.length}</span> Results</h4></TextContent>
                      <Toggle
                        onChange={({ detail }) => { 
                          setShowAiAppsOnly(detail.checked); 
                          setCurrentPageIndex(1);
                          const params = new URLSearchParams(ln.search);
                          if (detail.checked) { params.set('aiOnly', 'true'); } else { params.delete('aiOnly'); }
                          history.replace({ search: params.toString() });
                        }}
                        checked={showAiAppsOnly}
                      >
                        <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                          <Icon name="gen-ai" /> <strong>Show AI Apps Only</strong>
                        </span>
                      </Toggle>
                    </SpaceBetween>
                  }
                />
                {semanticPageItems.length > 0 && (
                  <>
                    <Box padding={{ bottom: "xs" }}>
                      <TextContent><h4><Icon name="gen-ai" /> Top Results <span style={{color: "#656871"}}>({displayProducts.filter(a => semanticIdSet.has(String(a.app_id))).length})</span></h4></TextContent>
                    </Box>
                    <Cards
                      className="apps-cards-container"
                      cardDefinition={appCardDefinition({ favoritesMap, favDisabled, favorite, ratingsMap, handleRatingChange, getUrl, history, featuredMap })}
                      cardsPerRow={[{ minWidth: 900, cards: 3 }]}
                      items={semanticPageItems}
                      loadingText="Loading resources"
                    />
                  </>
                )}
                {textMatchPageItems.length > 0 && (
                  <>
                    <Box padding={{ top: "l", bottom: "xs" }}>
                      <TextContent><h4><Icon name="search" /> More Results <span style={{color: "#656871"}}>({displayProducts.filter(a => !semanticIdSet.has(String(a.app_id))).length})</span></h4></TextContent>
                    </Box>
                    <Cards
                      className="apps-cards-container"
                      cardDefinition={appCardDefinition({ favoritesMap, favDisabled, favorite, ratingsMap, handleRatingChange, getUrl, history, featuredMap })}
                      cardsPerRow={[{ minWidth: 900, cards: 3 }]}
                      items={textMatchPageItems}
                      loadingText="Loading resources"
                    />
                  </>
                )}
                <Box float="right" padding={{ top: "m" }}>
                  <Pagination currentPageIndex={currentPageIndex}
                    key={`bottom-pagination-${showAiAppsOnly}`}
                    onChange={({ detail }) =>
                      setCurrentPageIndex(detail.currentPageIndex)
                    }
                    pagesCount={Math.ceil(displayProducts.length / 21) || 1}
                    openEnd={false} />
                </Box>
              </>
            ) : (
              <Cards
                className="apps-cards-container"
                cardDefinition={appCardDefinition({ favoritesMap, favDisabled, favorite, ratingsMap, handleRatingChange, getUrl, history, featuredMap })}
                stickyHeader
                cardsPerRow={[{ minWidth: 900, cards: 3 }]}
                items={pageItems}
                loadingText="Loading resources"
                empty={
                  isSearching ? <></> :
                  <Box textAlign="center" color="inherit">
                    <b>No applications</b>
                    <Box
                      padding={{ bottom: "s" }}
                      variant="p"
                      color="inherit"
                    >
                      No applications to display.
                    </Box>
                  </Box>
                }
                preferences = {
                  <>
                  {(!(abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled && aiAddAppAccessDisabled) ? 
                <ButtonDropdown
                items={[
                  { text: "ATEAM App", id: "ABC_APP", "href": "/App", disabled: abcAddAppAccessDisabled },
                  { text: "QSC App", id: "QSC_APP", "href": "/QSCApp", disabled: qscAddAppAccessDisabled },
                  { text: "RAC App", id: "RAC_APP", "href": "/RACApp", disabled: racAddAppAccessDisabled },
                  { text: "AI App", id: "AI_APP", "href": "/AIApp", disabled: aiAddAppAccessDisabled },
                ]}
                variant="primary"
                expandToViewport
              disabled={abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled && aiAddAppAccessDisabled}
              >
                Add to Repository
              </ButtonDropdown> : <></>
              )}
                  </>
                }
                pagination={
                  <Pagination currentPageIndex={currentPageIndex}
                    key={`main-pagination-${showAiAppsOnly}`}
                    onChange={({ detail }) =>
                      setCurrentPageIndex(detail.currentPageIndex)
                    }
                    pagesCount={Math.ceil(displayProducts.length / 21) || 1}
                    openEnd={false} />        
                }
                filter = {
                  <SpaceBetween direction="horizontal" size="m" alignItems="center">
                    <TextContent><h4><span style={{color: "#656871"}}>{pageItems
                      ? displayProducts.length
                      : ""}
                      </span> Results
                      </h4>
                    </TextContent>
                    <Toggle
                      onChange={({ detail }) => { 
                        setShowAiAppsOnly(detail.checked); 
                        setCurrentPageIndex(1);
                        const params = new URLSearchParams(ln.search);
                        if (detail.checked) { params.set('aiOnly', 'true'); } else { params.delete('aiOnly'); }
                        history.replace({ search: params.toString() });
                      }}
                      checked={showAiAppsOnly}
                    >
                      <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                        <Icon name="gen-ai" /> <strong>Show AI Apps Only</strong>
                      </span>
                    </Toggle>
                  </SpaceBetween>
                }
              />
            )
          ) :
                <Table
                  columnDefinitions={[
                    {
                      id: "fav",
                      cell: e => <div className={favDisabled ? "center_disabled" : "center"} disabled={favDisabled} >
                        {favoritesMap[e.app_id] && (<span style={{ cursor: "pointer", color:"#ff9900"}} onClick={() => favorite(e.app_id)}><Icon size= "medium" name="heart-filled"/></span>)}
                        {!favoritesMap[e.app_id] && (<span style={{ cursor: "pointer", color:"#ff9900"}} onClick={() => favorite(e.app_id)}><Icon size= "medium" name="heart"/></span>)}
                      </div>,
                      width: 50,
                      isRowHeader: true
                    },
                    {
                      id: "name",
                      header: "Name",
                      cell: e => <Link to={getUrl(e)}> {e.app_name}</Link>,
                      width: 300,
                    },
                    {
                      id: "app_description",
                      header: "Description",
                      cell: e => e.app_description,
                      width: 350,
                    },
                    {
                      id: "status",
                      header: "Status",
                      cell: e => (e.status ? (
                            e.status === 'Active' ?
                          <><span><Icon name="status-positive" variant="success" />&nbsp;<span style={{color: "#00802f"}}>{e.status}</span></span><br/></>
                          : e.status === 'Deprecated' ? 
                          <><span ><Icon name="status-negative" variant="error" />&nbsp;<span style={{color: "#db0000"}}>{e.status}</span></span><br/></>
                          : e.status === 'WIP' ?
                          <><span><Icon name="status-pending" variant="normal" />&nbsp;<span style={{color: "#0f141a"}}>{e.status}</span></span><br/></>
                          :<></>
                        ) :  <span><Icon name="status-warning" variant="warning" />&nbsp;<span style={{color: "#855900"}}>No status</span></span>),
                        // (e.status ? e.status : "No status"),
                      
                      width: 200,
                    },
                    {
                      id: "organization",
                      header: "Organization",
                      cell: e => (e.organization ? e.organization.join(', ') : "Not Available"),
                      width: 200,
                    },
                    {
                      id: "useCaseType",
                      header: "Use Case Type",
                      cell: e => (e.use_case ? e.use_case.join(', ') : "Not Available"),
                      width: 200,
                    },
                    {
                      id: "processOutput",
                      header: "Process output",
                      cell: e => (e.output ? getCommaSeperatedOutputs(e) : "Not Available"),
                      width: 200,
                    },
                    {
                      id: "vp",
                      header: "VP",
                      cell: e => (e.vp ? e.vp.join(', ') : "Not Available"),
                      width: 200,
                    }
                  ]}
                  items={pageItems}
                  loadingText="Loading resources"
                  resizableColumns
                  empty={
                    isSearching ? <></> :
                    <Box textAlign="center" color="inherit">
                      <b>No applications</b>
                      <Box
                        padding={{ bottom: "s" }}
                        variant="p"
                        color="inherit"
                      >
                        No applications to display.
                      </Box>
                    </Box>
                  }
                  header={cardsHeader}
                  pagination={
                    <Pagination currentPageIndex={currentPageIndex}
                      key={`search-pagination-${showAiAppsOnly}`}
                      onChange={({ detail }) =>
                        setCurrentPageIndex(detail.currentPageIndex)
                      }
                      pagesCount={Math.ceil(displayProducts.length / 21) || 1}
                      openEnd={false} />
                  }
                  filter={
                    <TextContent> <h4>Results <span style={{color: "#656871"}}>{pageItems
                      ? "(" + filteredProducts.length + ")"
                      : ""}
                      </span>
                      </h4>
                  </TextContent>
                  }
                />
              )}
    
          </>
        )    
        }
        </>
                    )
                  },
                  {
                    label: "My Favorites",
                    id: "favorites",
                    content: (<>
                      {loader ? (<Box padding={{ top: "l" }}>
                        <SkeletonCard count={4} />
                      </Box>) : (<Box>
                        <Cards
                          className="apps-cards-container"
                          cardDefinition={appCardDefinition({ favoritesMap, favDisabled, favorite, ratingsMap, handleRatingChange, getUrl, history, featuredMap })}
                          cardsPerRow={[{ minWidth: 900, cards: 3 }]}
                          items={favoriteProducts}
                          loadingText="Loading resources"
                          empty={
                            <Box textAlign="center" color="inherit">
                              <b>No Favorites</b>
                              <Box padding={{ bottom: "s" }} variant="p" color="inherit">No favorites to display.</Box>
                            </Box>
                          }
                        />
                      </Box>)}
                    </>)
                  },
                  // {
                  //   label: "My approvals",
                  //   id: "approvals",
                  //   content: <><ApprovalsHome/></>
                  // },
                  {
                    label: <span>Unpublished {pendingReviewCount !== null && <Badge color={pendingReviewFetchingMore ? "blue" : pendingReviewCount > 0 ? "red" : "green"}>{pendingReviewFetchingMore ? `${pendingReviewCount}+` : pendingReviewCount}</Badge>}</span>,
                    id: "unpublished",
                    href: "#unpublished",
                    content: (<>
                      {pendingReviewLoading ? (
                        <Box padding={{ top: "l" }}>
                          <SkeletonCard count={4} />
                        </Box>
                      ) : editingApp ? (
                        <Box padding={{ top: "l" }}>
                          <AutomatedAppEditForm
                            item={editingApp}
                            userId={userId}
                            onSave={(updatedItem) => {
                              if (updatedItem.status === "UNPUBLISHED") {
                                setPendingReviewApps((prev) =>
                                  prev.map((app) =>
                                    (app.resource_type === updatedItem.resource_type && app.resource_id === updatedItem.resource_id) ? updatedItem : app
                                  )
                                );
                              } else {
                                setPendingReviewApps((prev) =>
                                  prev.filter((app) => !(app.resource_type === updatedItem.resource_type && app.resource_id === updatedItem.resource_id))
                                );
                                setPendingReviewCount((prev) => prev - 1);
                              }
                              setEditingApp(null);
                            }}
                            onCancel={() => setEditingApp(null)}
                          />
                        </Box>
                      ) : (
                        <Box padding={{ top: "l" }}>
                          <SpaceBetween size="xs">
                            <SpaceBetween direction="horizontal" size="m" alignItems="center">
                              <TextContent><h4><span style={{color: "#656871"}}>{displayPendingReviewApps.length}</span> Results</h4></TextContent>
                              <Toggle
                                onChange={({ detail }) => { 
                                  setShowAiAppsOnly(detail.checked);
                                  const params = new URLSearchParams(ln.search);
                                  if (detail.checked) { params.set('aiOnly', 'true'); } else { params.delete('aiOnly'); }
                                  history.replace({ search: params.toString() });
                                }}
                                checked={showAiAppsOnly}
                              >
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                  <Icon name="gen-ai" /> <strong>Show AI Apps Only</strong>
                                </span>
                              </Toggle>
                            </SpaceBetween>
                            <SpaceBetween direction="horizontal" size="m">
                              <div style={{ width: "220px" }}>
                                <Input
                                  placeholder="Filter by App Name"
                                  value={pendingFilterAppName}
                                  onChange={({ detail }) => { setPendingFilterAppName(detail.value); setPendingReviewPageIndex(1); }}
                                />
                              </div>
                              <div style={{ width: "220px" }}>
                                <Input
                                  placeholder="Filter by App Builder (alias)"
                                  value={pendingFilterAppBuilder}
                                  onChange={({ detail }) => { setPendingFilterAppBuilder(detail.value); setPendingReviewPageIndex(1); }}
                                />
                              </div>
                              <div style={{ width: "220px" }}>
                                <Input
                                  placeholder="Filter by Director (alias)"
                                  value={pendingFilterDirector}
                                  onChange={({ detail }) => { setPendingFilterDirector(detail.value); setPendingReviewPageIndex(1); }}
                                />
                              </div>
                            </SpaceBetween>
                            <Box color="text-body-secondary" fontSize="body-s">These applications have been auto-created and are awaiting owner updates before publishing to the marketplace.</Box>
                          </SpaceBetween>

                          <div className="unpublished-cards-container" style={{ marginTop: "16px" }}>
                            {pendingReviewPageItems.length === 0 ? (
                              <Box textAlign="center" color="inherit" padding={{ top: "xl" }}>
                                <b>No pending apps to review.</b>
                                <Box variant="p" color="inherit" padding={{ bottom: "s" }}>
                                  You have no unpublished apps awaiting review.
                                </Box>
                              </Box>
                            ) : (
                              pendingReviewPageItems.map((item, idx) => (
                                <div
                                  key={item.resource_type + '#' + item.resource_id + idx}
                                  className="unpublished-card-item"
                                  onClick={() => setEditingApp(item)}
                                >
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                      <span style={{ fontSize: "16px", fontWeight: 700 }}>{item.app_name}</span>
                                      {item.template_id === TEMPLATES.AI && (
                                        <span className="ai-powered-badge"><Icon name="gen-ai" /> AI-Powered</span>
                                      )}
                                    </div>
                                    <span style={{ backgroundColor: "#fef3e8", color: "#d4760a", padding: "4px 12px", borderRadius: "8px", fontSize: "13px", fontWeight: 600 }}>Pending Review</span>
                                  </div>
                                  <Box color="text-body-secondary" margin={{ bottom: "xs" }}>{item.app_description}</Box>
                                  <Box fontSize="body-s" margin={{ bottom: "xs" }}>
                                    <SpaceBetween direction="horizontal" size="l">
                                      <span><span style={{ color: "#5f6b7a" }}>Created:</span> {item.created_at}</span>
                                      <span><span style={{ color: "#5f6b7a" }}>Last Modified:</span> {item.last_updated_at}</span>
                                      <span><span style={{ color: "#5f6b7a" }}>Created By:</span> {item.created_by}</span>
                                      <span><span style={{ color: "#5f6b7a" }}>App Builder:</span> {item.app_owner}</span>
                                    </SpaceBetween>
                                  </Box>
                                  <SpaceBetween direction="horizontal" size="l">
                                    <span className="edit-publish-link">Click to edit and publish →</span>
                                    <span className="discard-link" onClick={(e) => { e.stopPropagation(); setArchiveConfirmApp(item); }}>Discard</span>
                                  </SpaceBetween>
                                </div>
                              ))
                            )}
                          </div>

                          <Box float="right" padding={{ top: "s" }}>
                            <Pagination
                              currentPageIndex={pendingReviewPageIndex}
                              onChange={({ detail }) => setPendingReviewPageIndex(detail.currentPageIndex)}
                              pagesCount={pendingReviewPagesCount}
                            />
                          </Box>
                        </Box>
                      )}
                    </>)
                  },
                ]}
                activeTabId={appsActiveTabId}
                onChange={(event) => { 
                  setAppsActiveTabId(event.detail.activeTabId)
                  const newParams = new URLSearchParams(searchParams);
                  if (event.detail.activeTabId !== 'apps') {
                    newParams.set('section', event.detail.activeTabId);
                  } else {
                    newParams.delete('section');
                  }
                  history.push(`${ln.pathname}?${newParams.toString()}`)
                }}
              />

        {/* Discard Confirmation Modal */}
        {archiveConfirmApp && (
          <Modal
            visible={!!archiveConfirmApp}
            onDismiss={() => { setArchiveConfirmApp(null); setDiscardReason(""); }}
            header="Confirm Discard"
            footer={
              <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                  <Button onClick={() => { setArchiveConfirmApp(null); setDiscardReason(""); }}>Cancel</Button>
                  <Button variant="primary" disabled={!discardReason.trim()} onClick={() => {
                    updateAutomatedApp(
                      { ...archiveConfirmApp, status: "ARCHIVED", archival_reason: discardReason.trim() },
                      (response) => {
                        setPendingReviewApps(prev => prev.filter(app => 
                          !(app.resource_type === archiveConfirmApp.resource_type && app.resource_id === archiveConfirmApp.resource_id)
                        ));
                        setPendingReviewCount(prev => prev - 1);
                        setArchiveConfirmApp(null);
                        setDiscardReason("");
                      },
                      (error) => {
                        setArchiveConfirmApp(null);
                        setDiscardReason("");
                      }
                    );
                  }}>Discard</Button>
                </SpaceBetween>
              </Box>
            }
          >
            <SpaceBetween size="m">
              <Box>Are you sure you want to discard <Box variant="strong">{archiveConfirmApp?.app_name}</Box>?</Box>
              <Box>This will discard the application and remove it from the unpublished list.</Box>
              <FormField label="Reason for discarding" constraintText="Required">
                <Input
                  value={discardReason}
                  placeholder="Provide reason for discarding this application"
                  onChange={({ detail }) => setDiscardReason(detail.value)}
                />
              </FormField>
            </SpaceBetween>
          </Modal>
        )}

        </>
      )
      
    return (
       <>
       {Apps}
       </>
    );
}

export default Apps;
